<template class="full-height">
  <div class="group-travel-main full-height" style="padding: 15px">
    <!-- <el-dialog
      v-loading="listLoading"
      append-to-body
      modal-append-to-body
      title="預覽帳號設定"
      :visible.sync="dialogDemoAccountVisible"
      width="30%"
      v-if="demoAccounts && demoAccounts.length > 0"
    >
      <el-alert type="info" effect="dark">
        <template slot="title">
          <div>
            一個帳號只限同時間預覽一團，設定後將清除其他旅遊團預覽設定。
          </div>
          <div>
            預覽帳號可於【行程開始日期】之前，登入App，但無法使用以下功能：
          </div>
          <div>1，導覽功能</div>
          <div>2，推播通知</div>
        </template>
</el-alert>

<el-select style="margin: 5px; width: 100%" multiple v-if="demoAccounts" filterable clearable placeholder="請選擇可預覽的帳號"
  v-model="formData.demoAccounts">
  <el-option v-for="item in demoAccounts" :key="item.id" :label="`${item.account}-${item.name}`" :value="item.id" />
</el-select>

<span slot="footer" class="dialog-footer">
  <el-button @click="saveDemoAccounts" type="success">儲 存</el-button>

  <el-button @click="dialogDemoAccountVisible = false" type="danger">關 閉</el-button>
</span>
</el-dialog> -->
    <!-- 公告設定 -->
    <el-dialog
      title="旅遊團公告設定"
      :visible.sync="dialogTravelBulletinBoardVisible"
      width="90%"
      @open="handleDialogOpen"
      @close="handleClose"
    >
      <TravelBulletinBoard
        v-model="bulletinList"
        :travelId="selectedTravelID"
        @on-save="handleBulletinSave"
        @on-delete="handleBulletinDelete"
      />

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeDialogTravelBulletinBoardVisible" type="info"
          >關 閉</el-button
        >
      </span>
    </el-dialog>

    <!-- 日期登入設定 -->
    <el-dialog
      @open="doGetLoginDate"
      title="旅遊團日期登入"
      :visible.sync="dialogLoginDateVisible"
      width="400px"
      custom-class="custom-dialog"
    >
      <div>
        <el-form>
          <el-form-item label="日期登入設定" label-width="100px" prop="bulletinBoard">
            <!-- <el-tag type="success" style="height: auto; white-space: break-spaces; font-size: 14px"
              >開啟此設定後App可使用指定日期以及自訂姓名登入。</el-tag
            > -->
            <el-switch
              style="display: block"
              v-model="formData.loginDateEnable"
              active-color="#409eff"
              inactive-color="#ff4949"
              active-text="開啟"
              inactive-text="關閉"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch>
            <hr />
            <el-date-picker
              :disabled="formData.loginDateEnable === false"
              style="width: 100%; font-size: 12px"
              v-model="formData.loginDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="選擇日期"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="warning" @click="doSaveLoginDate"> 儲 存 </el-button>
        <el-button size="mini" @click="dialogLoginDateVisible = false" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog>

    <!-- APP說明會影片，點擊觀看次數 -->
    <el-dialog
      append-to-body
      modal-append-to-body
      :top="dialogTopMargin"
      :title="`【${travelName} 】旅客查看說明會影片紀錄`"
      :visible.sync="travelSeminarMovieEventVisible"
      width="55%"
    >
      <el-card class="box-card" style="overflow-y: auto">
        <div style="max-height: 450px">
          <div style="position: relative; height: 100%">
            <el-table
              size="mini"
              :data="travelSeminarMovieEvent"
              border
              fit
              highlight-current-row
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="姓名">
                <template slot-scope="scope">
                  <span> {{ `${scope.row.userName}` }} </span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="明細">
                <template slot-scope="scope">
                  <span> {{ `${scope.row.dateTime}` }} </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="travelSeminarMovieEventVisible = false" type="danger">關 閉</el-button>
      </span>
    </el-dialog>

    <!-- 旅遊團建立方式 -->
    <el-dialog
      title="選擇旅遊團建立模式"
      :visible.sync="dialogTravelChoiceVisible"
      width="400px"
      custom-class="custom-dialog"
    >
      <div class="option-container">
        <div
          :class="['option', 'manual', { active: selectedTravelCreateMode === 'manual' }]"
          @click="selectOption('manual')"
        >
          <i class="el-icon-edit"></i>
          <span>手動輸入</span>
        </div>
        <div
          :class="['option', 'ai', { active: selectedTravelCreateMode === 'ai' }]"
          @click="selectOption('ai')"
        >
          <i class="el-icon-cpu"></i>
          <span>AI智能</span>
        </div>
      </div>
    </el-dialog>

    <!-- AI匯入 -->
    <el-dialog
      v-loading="listLoading"
      append-to-body
      modal-append-to-body
      :title="`旅遊團AI匯入`"
      :visible.sync="dialogTravelFormVisible"
      width="30%"
    >
      <el-form ref="travelFormData" :model="travelFormData" label-width="120px">
        <!--
        <el-form-item label="旅遊團名稱">
          <el-tag>{{ travelFormData.travelName }}</el-tag>
        </el-form-item> -->

        <el-form-item label="表單">
          <div>
            <el-row>
              <el-col :span="20">
                <div>
                  <Upload
                    ref="uploadRefTravel"
                    :accept="'.pdf,.docx'"
                    :payload="travelFormData"
                    :data-obj="travelFileObj"
                    :limitText="'檔案須為.pdf或docx格式，限制不超過2000MB'"
                    :limit-file-count="20"
                    :use-drag="false"
                    :action="'TravelSettings/TravelInfoAnalytics'"
                    :auto-upload="false"
                    :show-file-list="true"
                    :form-on-loading-parent="formLoading"
                    :btn-txt="'上傳旅遊團文件'"
                    :before-file-list="
                      travelFormData.commonForms && travelFormData.commonForms.length
                        ? travelFormData.commonForms[0].files
                        : []
                    "
                  />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="warning" @click="doTravelInfoAnalytics"> 送 出 </el-button>
        <el-button size="mini" @click="dialogTravelFormVisible = false" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog>

    <!-- 領隊登入/登出紀錄 -->
    <el-dialog
      v-if="currentLeaderRecordRow && currentLeaderRecordRow.loginTimes"
      append-to-body
      :title="`【${currentLeaderRecordRow.userName}】登入/登出紀錄`"
      :visible.sync="dialogLeaderLoginRecordVisible"
      width="30%"
    >
      <el-card class="box-card">
        <div>
          <div style="position: relative; height: 400px">
            <el-table
              v-loading="listLoading"
              size="mini"
              :data="currentLeaderRecordRow.loginTimes"
              border
              fit
              highlight-current-row
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="登入日期">
                <template slot-scope="scope">
                  <el-tag type="info" effect="plain" v-if="scope.row.type == 1">
                    {{ `${scope.row.dateTime}` }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="登出日期">
                <template slot-scope="scope">
                  <el-tag type="danger" effect="plain" v-if="scope.row.type == 2">
                    {{ `${scope.row.dateTime}` }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLeaderLoginRecordVisible = false" type="danger">關 閉</el-button>
      </span>
    </el-dialog>

    <!-- 旅客登入/登出紀錄 -->
    <el-dialog
      v-if="currentTravelersRecordRow && currentTravelersRecordRow.loginTimes"
      append-to-body
      :title="`【${currentTravelersRecordRow.name}】登入/登出紀錄`"
      :visible.sync="dialogTravelersLoginRecordVisible"
      width="30%"
    >
      <el-card class="box-card">
        <div>
          <div style="position: relative; height: 400px">
            <el-table
              v-loading="listLoading"
              size="mini"
              :data="currentTravelersRecordRow.loginTimes"
              border
              fit
              highlight-current-row
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="登入日期">
                <template slot-scope="scope">
                  <el-tag type="info" effect="plain" v-if="scope.row.type == 1">
                    {{ `${scope.row.dateTime}` }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="登出日期">
                <template slot-scope="scope">
                  <el-tag type="danger" effect="plain" v-if="scope.row.type == 2">
                    {{ `${scope.row.dateTime}` }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTravelersLoginRecordVisible = false" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog>
    <!-- 天氣地點顯示設定 -->
    <el-dialog
      width="30%"
      modal-append-to-body
      append-to-body
      :visible.sync="dialogPostitionSubVisible"
      :title="`【${formData.travelName}】天氣地點顯示設定`"
      :top="'30vh'"
      :close-on-click-modal="false"
    >
      <el-alert
        v-if="positionMsg !== null"
        :title="positionMsg"
        effect="dark"
        :closable="false"
        style="background-color: #ffd643; color: #4b4b4b"
      ></el-alert>
      <div>
        <el-select
          style="width: 100%; margin-top: 10px"
          multiple
          v-if="positionSubOptions"
          v-model="formData.position"
          filterable
          clearable
          placeholder="請選擇地點"
          :disabled="permissionCheck(formData.status)"
        >
          <el-option
            v-for="item in positionSubOptions"
            :key="item.positionID"
            :label="`${item.country}-${item.city}`"
            :value="item.positionID"
          />
        </el-select>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPostitionSubVisible = false" type="danger">關 閉</el-button>
      </div>
    </el-dialog>
    <!-- 定位足跡紀錄 -->
    <el-dialog
      append-to-body
      v-if="
        currentPositionData && currentPositionData.records && currentPositionData.records.length > 0
      "
      :title="
        currentPlanningDescription !== ''
          ? `${referenceDate} 定位足跡紀錄，\n行程說明：【${currentPlanningDescription}】`
          : `${referenceDate} 定位足跡紀錄`
      "
      :visible.sync="positionDialogVisible"
      top="2%"
      width="70%"
    >
      <div style="position: relative; height: 100%; padding: 8px 0px">
        <!-- TODO: 新增集合地點 -->
        <el-alert type="error" :closable="false">
          <p style="line-height: 0; font-size: 15px; letter-spacing: 0.05em">
            可點選座標圖示查看旅行團當下數據資訊
          </p>
        </el-alert>
        <Map v-if="positionDialogVisible" :records="currentPositionData.records" />
        <el-table
          v-loading="listLoading"
          size="mini"
          :data="currentPositionData.records"
          border
          fit
          highlight-current-row
          height="300px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="日期" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.date }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="景點">
            <template slot-scope="scope">
              <span>{{ scope.row.viewPointName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="集合時間" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.gatherAroundDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="到達時間" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="離開時間" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.leaveTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="停留時間" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.dwellTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="北緯" width="110">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.lat" type="success">{{ scope.row.lat }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="東經" width="110">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.lng" type="success">{{ scope.row.lng }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="功能">
            <template slot-scope="scope" v-if="scope.row.lat && scope.row.lng">
              <el-row>
                <el-col :span="12">
                  <el-button
                    size="mini"
                    @click="googleMap(scope.row)"
                    icon="el-icon-position"
                    type="success"
                    >查看Google地圖</el-button
                  ></el-col
                >
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- <el-dialog
      v-if="referenceUser"
      :top="dialogTopMargin"
      :title="`${referenceDate}旅遊團足跡紀錄`"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-card class="box-card">
        <el-form
          :inline="true"
          ref="form"
          :model="form"
          :label-width="formLabelWidth"
          :disabled="true"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item :label="'日期'">
                <el-tag style="margin-left: 5px" type="success">{{
                  `${referenceDate}`
                }}</el-tag>
              </el-form-item>

              <el-form-item :label="'足跡人員'">
                <el-tag style="margin-left: 5px" type="success">{{
                  `${referenceUser.cUserName}`
                }}</el-tag>
              </el-form-item>

              <div style="position: relative; height: 80%">
                <el-table
                  v-loading="listLoading"
                  size="mini"
                  :data="referenceData"
                  border
                  fit
                  highlight-current-row
                  height="600px"
                >
                  <el-table-column align="center" label="項次" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="日期" width="120">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.date }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="景點數量" width="120">
                    <template slot-scope="scope">
                      <el-tag type="danger">{{
                        scope.row.records.length
                      }}</el-tag>
                      個景點
                    </template>
                  </el-table-column>

                  <el-table-column
                    align="center"
                    label="查看足跡紀錄"
                    width="400"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        @click="viewReferenceData(scope.row)"
                        :disabled="false"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div></div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog> -->
    <!-- 貨幣設定 -->
    <el-dialog
      width="30%"
      append-to-body
      :visible.sync="dialoCurrencySubVisible"
      :title="`【${formData.travelName}】貨幣設定`"
    >
      <el-alert
        v-if="currencyMsg"
        :title="currencyMsg"
        type="warning"
        effect="dark"
        :closable="false"
      ></el-alert>

      <el-select
        style="margin-top: 10px; width: 100%"
        @change="dialoCurrencySubVisible = false"
        v-if="currencySubOptions"
        v-model="formData.currency"
        filterable
        clearable
        placeholder="請選擇貨幣"
      >
        <el-option
          v-for="item in currencySubOptions"
          :key="item.key"
          :label="`${item.val}-${item.key}`"
          :value="item.key"
        />
      </el-select>
    </el-dialog>
    <!-- 網卡購買 -->
    <el-dialog
      @open="getCurrentNetworkCardPostFee"
      width="60%"
      append-to-body
      :visible.sync="dialoNetworkSettingVisible"
      :title="`【${travelName}】網卡購買`"
      v-loading="dialoNetworkSettingLoading"
      top="2%"
    >
      <div>
        <el-alert
          type="info"
          :closable="false"
          style="background-color: #ffd643; color: #4b4b4b; margin-bottom: 10px"
          title="網卡購買將於出國前三天開始禁止下單及更改，以利廠商出貨作業"
        >
          <!--<template slot="title">
            <div>
              <div style="color: red">
                網卡購買將於出國前三天開始禁止下單及更改，以利廠商出貨作業
              </div>
               如果需要，選完網卡和數量後，接著單選題
              <div>
                ○ 寄送至貴公司，出國前1~2天送達，<span style="color: blue"
                  >免運費</span
                >
              </div>
              <div>
                ○ 親送至桃園機場交付領隊，運費<span style="color: red"
                  >{{ currentNetworkCardFee }} 元。</span
                >
              </div>
            </div>
          </template> -->
        </el-alert>

        <el-row style="margin-bottom: 10px">
          <el-switch
            v-show="currentNetworkStatus"
            v-model="selectedNetworkRow.networkCard"
            active-text="需要"
            inactive-text="不需要"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-row>

        <el-row v-if="selectedNetworkRow.networkCard" style="margin-bottom: 10px">
          <el-select
            @change="selectedNetworkDesc"
            :disabled="!currentNetworkStatus"
            v-model="selectedNetworkRow.cardID"
            size="mini"
            placeholder="選擇網卡"
            style="width: 40%"
          >
            <el-option
              v-for="item in selectedNetworkRow.networkOptions"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>

          <el-select
            :disabled="!currentNetworkStatus"
            v-model="selectedNetworkRow.cardCount"
            size="mini"
            placeholder="選擇數量"
            style="width: 20%; margin-left: 10px"
          >
            <el-option
              v-for="item in netWordcardDefaultOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-tag size="mini" type="danger" style="margin-left: 10px">張</el-tag>
        </el-row>

        <el-row>
          <el-col v-if="currentNetworkDesc" :span="10">
            <div>
              <el-input disabled :rows="20" type="textarea" v-model="currentNetworkDesc"></el-input>
            </div>
          </el-col>
          <el-col :span="14">
            <div
              :style="{
                marginLeft: currentNetworkDesc ? '10px' : '0px',
                padding: '6px',
                border: '1px solid #ccc',
                borderRadius: '4px',
              }"
              v-show="selectedNetworkRow.networkCard"
            >
              <!-- <el-tag style="margin-bottom: 10px">網卡寄送方式</el-tag> -->
              <span>網卡寄送方式</span>
              <el-radio-group v-model="selectedNetworkRow.postMode" style="margin-top: 10px">
                <el-radio :label="1" style="margin-bottom: 20px" :disabled="!currentNetworkStatus"
                  >寄送至貴公司，出國前1~2天送達，免運費（需下單至少10張即可免運）
                </el-radio>
                <!-- <el-radio :label="2" :disabled="!currentNetworkStatus">親送至桃園機場交付領隊，運費{{
                  currentNetworkCardFee
                }}元</el-radio> -->
                <el-radio :label="2" :disabled="!currentNetworkStatus"
                  >前往本公司親自領取（高鐵桃園站前步行五分鐘）</el-radio
                >
              </el-radio-group>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-show="currentNetworkStatus"
          type="warning"
          style="margin-left: 5px; color: #4b4b4b"
          @click="saveTravelNetworkSetting"
          >儲 存</el-button
        >
        <el-button
          @click="dialoNetworkSettingVisible = false"
          :type="currentNetworkStatus ? '' : 'danger'"
          >{{ currentNetworkStatus ? '取消' : '關閉' }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 複製他團旅行物品 -->
    <el-dialog
      width="30%"
      append-to-body
      @opened="getAgencyTravelsAndOtherInformation"
      :visible.sync="dialoCarryItemsReferenceVisible"
      :title="`【${travelName}】複製他團旅行${carryItemCopyType == 1 ? '建議物品' : '必帶物品'}`"
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        "
      >
        <label class="el-form-item__label">旅遊團</label>
        <el-select
          v-loading="searchCarryItemsLoading"
          style="width: 60%; flex: 1"
          clearable
          v-model="selectedAgencyTravel"
          placeholder="請選擇"
          value-key="id"
        >
          <el-option
            v-for="item in agencyTravels.filter(f => f.id != selectedTravelID)"
            :key="item.id"
            :label="item.travelName"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-button
          type="warning"
          @click="doCopyCarryItems()"
          :disabled="searchCarryItemsLoading"
          style="color: #4b4b4b; margin-left: 5px"
          >儲存</el-button
        >
      </div>
      <div>
        <el-table
          v-loading="searchCarryItemsLoading"
          v-if="selectedAgencyTravel && selectedAgencyTravel.travelResultCarryItems"
          :data="selectedAgencyTravel.travelResultCarryItems.recommended.items"
          border
          style="width: 100%"
          height="500"
        >
          <el-table-column label="項次" width="50" align="center">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="description" label="項目" align="center">
            <template slot-scope="scope">
              <el-tag size="mini">{{ scope.row.description }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 攜帶物品設定 -->
    <el-dialog
      class="carryItem-dialog"
      width="80%"
      top="2vh"
      :visible.sync="dialoCarryItemsVisible"
      :title="`【${travelName}】攜帶物品設定`"
      v-loading="carryItemsLoading"
    >
      <el-tabs type="border-card" v-if="carryItems" v-model="carryItemsTab" style="height: 100%">
        <el-tab-pane label="旅行必帶物品" name="required">
          <div>
            <el-row>
              <el-col :span="8">
                <el-button
                  v-show="!permissionCheck(formData.status)"
                  type="success"
                  @click="setCopyCarryItemType(2)"
                  style="margin-bottom: 10px"
                  >複製他團旅行必帶物品</el-button
                >
                <el-form v-show="!permissionCheck(formData.status)">
                  <el-form-item label="建議事項描述">
                    <el-input placeholder="請輸入建議事項描述" v-model="carryItems.required.remark">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="新增項目">
                    <el-tag
                      type="warning"
                      style="height: auto; white-space: break-spaces; font-size: 14px"
                      >使用符號 | 分隔可一次建立多筆資料。例：身分證|護照</el-tag
                    >
                    <el-input
                      placeholder="請輸入項目"
                      v-model="newCarryItem.description"
                      class="input-with-select"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-plus"
                        style="background-color: #e6a23c; border-color: #e6a23c; color: #ffffff"
                        @click="addCarryItem('required')"
                      ></el-button
                      >新增
                    </el-input>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="14" :offset="1">
                <el-table
                  :data="carryItems.required.items"
                  border
                  style="width: 100%"
                  :key="carryItemsTab"
                >
                  <el-table-column label="項次" width="50" align="center">
                    <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                  </el-table-column>
                  <el-table-column prop="description" label="項目" align="center">
                    <template slot-scope="scope">
                      <el-input size="mini" v-model="scope.row.description"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="description"
                    label="刪除"
                    width="150"
                    align="center"
                    v-if="!permissionCheck(formData.status)"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-show="!permissionCheck(formData.status)"
                        type="danger"
                        size="mini"
                        @click="deleteCarryItem('required', scope.$index)"
                        >刪除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>

        <el-tab-pane label="旅行建議物品" name="recommended">
          <div>
            <el-row>
              <el-col :span="8">
                <el-button
                  v-show="!permissionCheck(formData.status)"
                  type="success"
                  @click="setCopyCarryItemType(1)"
                  style="margin-bottom: 10px"
                  >複製他團旅行建議物品</el-button
                >
                <el-form v-show="!permissionCheck(formData.status)">
                  <el-form-item label="建議事項描述">
                    <el-input
                      placeholder="請輸入建議事項描述"
                      v-model="carryItems.recommended.remark"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item label="新增項目">
                    <el-tag
                      type="warning"
                      style="height: auto; white-space: break-spaces; font-size: 14px"
                      >使用符號 | 分隔可一次建立多筆資料。例：身分證|護照</el-tag
                    >
                    <el-input
                      placeholder="請輸入項目"
                      v-model="newCarryItem.description"
                      class="input-with-select"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-plus"
                        style="background-color: #e6a23c; border-color: #e6a23c; color: #ffffff"
                        @click="addCarryItem('recommended')"
                      ></el-button
                      >新增
                    </el-input>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="14" :offset="1">
                <el-table
                  :data="carryItems.recommended.items"
                  border
                  style="width: 100%"
                  :key="carryItemsTab"
                >
                  <el-table-column label="項次" width="50" align="center">
                    <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                  </el-table-column>
                  <el-table-column prop="description" label="項目" align="center">
                    <template slot-scope="scope">
                      <el-input size="mini" v-model="scope.row.description"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="description"
                    label="刪除"
                    width="150"
                    align="center"
                    v-if="!permissionCheck(formData.status)"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-show="!permissionCheck(formData.status)"
                        type="danger"
                        size="mini"
                        @click="deleteCarryItem('recommended', scope.$index)"
                        >刪除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button
          v-show="!permissionCheck(formData.status)"
          @click="settingCarryItems"
          type="warning"
          style="color: #4b4b4b"
        >
          儲 存
        </el-button>
        <el-button @click="dialoCarryItemsVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 座位設定 -->
    <el-dialog
      custom-class="seat-dialog"
      width="80%"
      top="0.3%"
      :visible.sync="dialoSeatFormsVisible"
      :title="`【${travelName}】座位設定`"
    >
      <seat
        :isCanSave="!permissionCheck(formData.status)"
        v-if="!seatType || seatType == 1"
        :isRefresh="isRefreshSeat"
        :fatherDialogFormVisible="fatherDialogSeatFormVisible"
        :callback="seatCallback"
        :travelID="selectedTravelID"
      >
      </seat>

      <seat-second
        :isCanSave="!permissionCheck(formData.status)"
        v-if="seatType == 2"
        :isRefresh="isRefreshSeat"
        :fatherDialogFormVisible="fatherDialogSeatFormVisible"
        :callback="seatCallback"
        :travelID="selectedTravelID"
      ></seat-second>
    </el-dialog>
    <!-- <el-dialog
      top="2%"
      :visible.sync="dialoCommonFormsVisible"
      :title="'常用表單維護'"
    >
      <el-card class="box-card" v-loading="commonFormsLoading">
        <div slot="header" class="clearfix">
          <span>旅遊團常用表單上傳(最多一次同時上傳20個檔案)</span>
        </div>
        <div>
          <el-row>
            <el-col :span="20">
              <Upload
                ref="uploadCommonFormsRef"
                :accept="'.doc,.pdf,.xls,.xlsx,.docx'"
                :payload="formData"
                :data-obj="fileObj"
                :limit-file-count="20"
                :use-drag="false"
                :action="'TravelSettings/saveGroupTourCommonForms'"
                :auto-upload="false"
                :show-file-list="true"
                :form-on-loading-parent="formLoading"
                :btn-txt="'選擇表單'"
                :before-file-list="
                  formData.commonForms && formData.commonForms.length
                    ? formData.commonForms[0].files
                    : []
                "
              />
            </el-col>

            <el-col :span="4">
              <el-button
                type="success"
                size="mini"
                @click="doUploadCommonForms"
              >
                確定
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-dialog> -->

    <!-- <el-dialog
      @open="onCouponDiglogOpenHandler"
      append-to-body
      top="2%"
      :visible.sync="dialogCouponListVisible"
      :title="'優惠票券選擇'"
    >
      <coupon-list
        :travelID="selectedTravelID"
        ref="couponListRef"
        :fatherDialogFormVisible="fatherCouponListDialogFormVisible"
        :saveSuccess="saveCouponSuccess"
      ></coupon-list>
    </el-dialog> -->

    <!-- <el-dialog
      v-if="couponFormData"
      append-to-body
      @closed="onCouponDialogClosed"
      top="2%"
      width="80%"
      :visible.sync="dialogCouponFormVisible"
      :title="'優惠票券維護'"
    >
      <coupon-data
        :formData="couponFormData"
        :categories="categories"
        ref="couponDataRef"
        :travelID="selectedTravelID"
        :fatherDialogFormVisible="fatherCouponDialogFormVisible"
        :saveSuccess="saveCouponSuccess"
      ></coupon-data>
    </el-dialog> -->

    <!-- 查看or編輯 -->
    <el-dialog
      @closed="onDialogClosed"
      :title="
        formData.id ? `維護旅遊資料 【紀錄保留至 ${formData.dataLimitInfo}】` : `維護旅遊資料`
      "
      :visible.sync="dialogFormVisible"
      width="100%"
      fullscreen
      style="border: 2px solid #ccc"
      class="editForm"
    >
      <el-card class="box-card" v-loading="formLoading" :body-style="{ border: '1px solid #ccc' }">
        <el-form
          ref="dynamicValidateForm"
          :model="formData"
          :disabled="permissionCheck(formData.status)"
          label-position="right"
        >
          <div class="edit-travel">
            <div>
              <el-form-item
                label="團號"
                :label-width="formLabelWidth"
                prop="tourGroupNo"
                :rules="[
                  {
                    required: true,
                    message: '請輸入團號',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  class="tourGroupNoInput"
                  v-model="formData.tourGroupNo"
                  :disabled="!isAdd && !modifyTourNo"
                  autocomplete="off"
                  placeholder="請輸入團號"
                />
              </el-form-item>

              <el-form-item
                label="團名"
                :label-width="formLabelWidth"
                prop="travelName"
                :rules="[
                  {
                    required: true,
                    message: '請輸入團名',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="formData.travelName"
                  autocomplete="off"
                  placeholder="請輸入團名"
                />
              </el-form-item>

              <el-form-item
                v-show="checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN'])"
                label="旅行社名稱"
                :label-width="formLabelWidth"
                prop="agencyCode"
                :rules="[
                  {
                    required: checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN']) ? true : false,
                    message: '請選擇旅行社名稱',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  v-model="formData.agencyCode"
                  filterable
                  placeholder="請選擇"
                  :disabled="agencyOptionDisabled"
                  class="w-full-select"
                >
                  <el-option
                    v-for="item in agencyList"
                    :key="item.key"
                    :label="item.val"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>

              <el-form-item
                label="旅遊性質"
                :label-width="formLabelWidth"
                prop="travelProperty"
                :rules="[
                  {
                    required: true,
                    message: '請選擇旅遊性質',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  v-model="formData.travelProperty"
                  filterable
                  placeholder="請選擇"
                  class="w-full-select"
                >
                  <el-option
                    v-for="item in travelPropertyOption"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>

              <el-form-item
                label="團體類別"
                :label-width="formLabelWidth"
                prop="travelAttributes"
                :rules="[
                  {
                    required: true,
                    message: '請選擇旅遊屬性',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  v-model="formData.travelAttributes"
                  filterable
                  placeholder="請選擇"
                  class="w-full-select"
                  @change="chkTravelAttributesOption"
                >
                  <el-option
                    v-for="item in travelAttributesOption"
                    :key="item.key"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item
                label="國家/區域"
                :label-width="formLabelWidth"
                prop="countryAreaList"
                :rules="[
                  {
                    required: true,
                    message: '請選擇國家區域',
                    trigger: 'change',
                  },
                ]"
              >
                <div class="block">
                  <el-cascader
                    :disabled="formData.travelAttributes == 1"
                    popper-class="travel-data-cascader"
                    @change="getPositionAndCouurncy()"
                    clearable
                    collapse-tags
                    v-model="formData.countryAreaList"
                    :props="{
                      multiple: true,
                      checkStrictly: false,
                      expandTrigger: 'hover',
                    }"
                    style="width: 100%"
                    placeholder="請選擇"
                    filterable
                    :options="travelAttractionsMenu"
                  >
                  </el-cascader>
                </div>
              </el-form-item>

              <el-form-item
                label="貨幣"
                :label-width="formLabelWidth"
                prop="currency"
                :rules="[
                  {
                    required: true,
                    message: '請選擇旅遊貨幣',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  style="width: 100%"
                  v-model="formData.currency"
                  filterable
                  clearable
                  placeholder="請選擇"
                  :disabled="formData.travelAttributes == 1 || formData.travelAttributes == 3"
                >
                  <el-option
                    v-for="item in currencyOptions"
                    :key="item.key"
                    :label="`${item.val}-${item.key}`"
                    :value="item.key"
                  />
                </el-select>

                <el-button
                  type="primary"
                  size="mini"
                  v-if="currencySubOptions.length > 0"
                  @click="dialoCurrencySubVisible = true"
                  >區域貨幣選單</el-button
                >
              </el-form-item>

              <el-form-item label="其他設定" :label-width="formLabelWidth" prop="showTravelInfo">
                <el-form :inline="true" class="demo-form-inline other-setting">
                  <el-form-item
                    label="顯示資訊"
                    style="border: 1px solid #ccc; padding: 5px; border-radius: 4px"
                  >
                    <el-tooltip
                      content="是否需要顯示旅行社名稱以及圖片至App"
                      placement="bottom"
                      effect="light"
                    >
                      <!-- <el-radio-group v-model="formData.showTravelInfo" size="small"
                        :disabled="permissionCheck(formData.status)">
                        <el-radio-button :label="true">顯示</el-radio-button>
                        <el-radio-button :label="false">隱藏</el-radio-button>
                      </el-radio-group> -->
                      <el-switch
                        v-model="formData.showTravelInfo"
                        active-color="#13ce66"
                        :disabled="permissionCheck(formData.status)"
                        inactive-color="#ccc"
                        active-text="顯示"
                        inactive-text="隱藏"
                        :active-value="true"
                        :inactive-value="false"
                      >
                      </el-switch>
                    </el-tooltip>
                  </el-form-item>
                  <el-form-item
                    v-if="formData"
                    label="旅遊天氣設定"
                    style="border: 1px solid #ccc; padding: 5px; border-radius: 4px"
                  >
                    <el-button
                      style="margin-left: 10px"
                      @click="showPosition"
                      size="mini"
                      type="primary"
                      >{{ !permissionCheck(formData.status) ? '設定' : '查看' }}</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-form-item>

              <el-row>
                <el-col :span="24" :lg="12">
                  <el-form-item label="去程班機" :label-width="formLabelWidth" prop="flightGoInfo">
                    <el-input
                      v-model="formData.flightGoInfo"
                      autocomplete="off"
                      placeholder="請輸入班機號碼及時間"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24" :lg="12">
                  <el-form-item
                    label="回程班機"
                    :label-width="formLabelWidth"
                    prop="flightReturnInfo"
                  >
                    <el-input
                      v-model="formData.flightReturnInfo"
                      autocomplete="off"
                      placeholder="請輸入班機號碼及時間"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24" :lg="12">
                  <el-form-item label="遊覽車" :label-width="formLabelWidth" prop="tourBusInfo">
                    <el-input
                      v-model="formData.tourBusInfo"
                      autocomplete="off"
                      placeholder="請輸入車牌號碼"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24" :lg="12">
                  <el-form-item label="集合地點" :label-width="formLabelWidth" prop="tourBusInfo">
                    <el-input
                      v-model="formData.gatherAroundLocation"
                      autocomplete="off"
                      placeholder="請輸入集合地點"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <div style="bottom: 0px" class="travel-time">
                <el-form-item
                  label="行程開始"
                  :label-width="'100px'"
                  style="border: solid 1px #ccc; padding: 5px; background-color: azure"
                >
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="13">
                      <el-form-item
                        prop="beginDate"
                        :rules="[
                          {
                            required: true,
                            message: '請選擇行程開始日期',
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-card :body-style="{ padding: '0px' }">
                          <div style="padding: 14px 0">
                            <span>行程開始日期</span>
                            <div class="bottom clearfix">
                              <!-- ITA-系統開發權限（ITA-DEV）、ITA-系統管理員權限（ITA-ADMIN）、ITA-管理行政(旅行社)（ITA-ADM-STAFF）、ITA-客服後台管理員（SERVICE-ADMIN）、 ITA-客服人員（ITA-SER-STAFF）、ITA-客服-團體APP（ITA-SER-STAFF-GROUP）、ITA-業務人員（ITA-SALES）-->
                              <el-date-picker
                                :disabled="
                                  !isAdd &&
                                  !checkPermission([
                                    'ITA-DEV',
                                    'ITA-ADMIN',
                                    'ITA-ADM-STAFF',
                                    'SERVICE-ADMIN',
                                    'ITA-SER-STAFF',
                                    'ITA-SER-STAFF-GROUP',
                                    'ITA-SALES',
                                  ])
                                "
                                :clearable="false"
                                @change="checkDefault($event, 'departureDate')"
                                style="width: 100%; font-size: 12px"
                                v-model="formData.beginDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="選擇日期"
                                :picker-options="pickerBeginDateLimitOptions"
                              />
                            </div>
                          </div>
                        </el-card>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="11">
                      <el-form-item
                        prop="beginTime"
                        :rules="[
                          {
                            required: true,
                            message: '請選擇集合出發時間',
                            trigger: 'blur',
                          },
                        ]"
                        ><el-card :body-style="{ padding: '0px' }">
                          <div style="padding: 14px 0">
                            <span>集合出發時間</span>
                            <div class="bottom clearfix">
                              <el-time-select
                                :clearable="false"
                                @change="checkDefault($event, 'departureTime')"
                                style="width: 100%; font-size: 12px"
                                v-model="formData.beginTime"
                                :picker-options="{
                                  start: '00:00',
                                  step: '00:15',
                                  end: '23:45',
                                }"
                                placeholder="選擇時間"
                              />
                            </div>
                          </div> </el-card
                      ></el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" v-show="false">
                      <el-form-item
                        prop="departureDate"
                        :rules="[
                          {
                            required: !formData.countryAreaList.some(x => x == 'region_10')
                              ? true
                              : false,
                            message: '請輸入班機出發日期',
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-card :body-style="{ padding: '0px' }">
                          <div style="padding: 14px">
                            <span style="color: #712cf9">班機出發日期</span>
                            <div class="bottom clearfix">
                              <el-date-picker
                                style="width: 100%; font-size: 12px"
                                v-model="formData.departureDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="選擇日期"
                              />
                            </div>
                          </div>
                        </el-card>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" v-show="false">
                      <el-form-item
                        prop="departureTime"
                        :rules="[
                          {
                            required: !formData.countryAreaList.some(x => x == 'region_10')
                              ? true
                              : false,
                            message: '請輸入班機出發時間',
                            trigger: 'blur',
                          },
                        ]"
                        ><el-card :body-style="{ padding: '0px' }">
                          <div style="padding: 14px">
                            <span style="color: #712cf9">班機出發時間</span>
                            <div class="bottom clearfix">
                              <el-time-select
                                style="width: 100%; font-size: 12px"
                                v-model="formData.departureTime"
                                :picker-options="{
                                  start: '00:00',
                                  step: '00:15',
                                  end: '23:45',
                                }"
                                placeholder="選擇時間"
                              />
                            </div>
                          </div> </el-card
                      ></el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item
                  label="行程結束"
                  :label-width="'100px'"
                  style="border: solid 1px #ccc; padding: 5px; background-color: antiquewhite"
                >
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="13">
                      <el-form-item
                        prop="endDate"
                        :rules="[
                          {
                            required: true,
                            message: '請選擇行程結束日期',
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-card :body-style="{ padding: '0px' }">
                          <div style="padding: 14px 0">
                            <span>行程結束日期</span>
                            <div class="bottom clearfix">
                              <!-- ITA-系統開發權限（ITA-DEV）、ITA-系統管理員權限（ITA-ADMIN）、ITA-管理行政(旅行社)（ITA-ADM-STAFF）、ITA-客服後台管理員（SERVICE-ADMIN）、 ITA-客服人員（ITA-SER-STAFF）、ITA-客服-團體APP（ITA-SER-STAFF-GROUP）、ITA-業務人員（ITA-SALES）-->
                              <el-date-picker
                                :disabled="
                                  !isAdd &&
                                  !checkPermission([
                                    'ITA-DEV',
                                    'ITA-ADMIN',
                                    'ITA-ADM-STAFF',
                                    'SERVICE-ADMIN',
                                    'ITA-SER-STAFF',
                                    'ITA-SER-STAFF-GROUP',
                                    'ITA-SALES',
                                  ])
                                "
                                :clearable="false"
                                :picker-options="pickerLimitOptions"
                                @change="checkDefault($event, 'returnDate')"
                                style="width: 100%; font-size: 12px"
                                v-model="formData.endDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="選擇日期"
                              />
                            </div>
                          </div>
                        </el-card>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="11">
                      <el-form-item
                        prop="endTime"
                        :rules="[
                          {
                            required: true,
                            message: '請選擇行程結束時間',
                            trigger: 'blur',
                          },
                        ]"
                        ><el-card :body-style="{ padding: '0px' }">
                          <div style="padding: 14px 0">
                            <span>行程結束時間</span>
                            <div class="bottom clearfix">
                              <el-time-select
                                :clearable="false"
                                @change="checkDefault($event, 'returnTime')"
                                style="width: 100%; font-size: 12px"
                                v-model="formData.endTime"
                                :picker-options="{
                                  start: '00:00',
                                  step: '00:15',
                                  end: '23:45',
                                }"
                                placeholder="選擇時間"
                              />
                            </div>
                          </div> </el-card
                      ></el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" v-show="false">
                      <el-form-item
                        prop="returnDate"
                        :rules="[
                          {
                            required: !formData.countryAreaList.some(x => x == 'region_10')
                              ? true
                              : false,
                            message: '請輸入班機回程日期',
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-card :body-style="{ padding: '0px' }">
                          <div style="padding: 14px">
                            <span style="color: #712cf9">班機回程日期</span>
                            <div class="bottom clearfix">
                              <el-date-picker
                                :picker-options="pickerFlightLimitOptions"
                                style="width: 100%; font-size: 12px"
                                v-model="formData.returnDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="選擇日期"
                              />
                            </div>
                          </div>
                        </el-card>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" v-show="false">
                      <el-form-item
                        prop="returnTime"
                        :rules="[
                          {
                            required: !formData.countryAreaList.some(x => x == 'region_10')
                              ? true
                              : false,
                            message: '請輸入班機回程時間',
                            trigger: 'blur',
                          },
                        ]"
                        ><el-card :body-style="{ padding: '0px' }">
                          <div style="padding: 14px">
                            <span style="color: #712cf9">班機回程時間</span>
                            <div class="bottom clearfix">
                              <el-time-select
                                style="width: 100%; font-size: 12px"
                                v-model="formData.returnTime"
                                :picker-options="{
                                  start: '00:00',
                                  step: '00:15',
                                  end: '23:45',
                                }"
                                placeholder="選擇時間"
                              />
                            </div>
                          </div> </el-card
                      ></el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>
            </div>

            <div>
              <!-- <el-form-item label="領隊公告" label-width="100px" prop="bulletinBoard">
                <el-input v-model="formData.bulletinBoard" type="textarea" :rows="6" />
              </el-form-item> -->
              <el-form-item label="領隊公告" label-width="100px">
                <div>
                  <el-row>
                    <el-button
                      v-if="selectedTravelID"
                      @click="dialogTravelBulletinBoardVisible = true"
                      >公告設定</el-button
                    >
                    <el-tag v-else>請先儲存才可建立公告 </el-tag>
                  </el-row>

                  <!-- <el-row>
                    <el-input v-model="formData.bulletinBoard" type="textarea" :rows="6" />
                  </el-row> -->
                  <el-row>
                    <div>
                      <UploadCustom
                        :span="24"
                        :btnStyle="'primary'"
                        ref="uploadBoardRef"
                        :accept="'.jpg,.jpeg,.bmp,.png'"
                        :payload="boardFileModel"
                        :data-obj="fileObj"
                        :limit-file-count="50"
                        :limitText="'圖片須為.jpg,.png,.bmp格式，限制不超過200MB'"
                        :use-drag="false"
                        :action="'TravelSettings/bulletinBoard'"
                        :auto-upload="false"
                        :show-file-list="true"
                        :form-on-loading-parent="formLoading"
                        :btn-txt="'上傳'"
                        :before-file-list="
                          formData.bulletinBoardData &&
                          formData.bulletinBoardData.fileInfo &&
                          formData.bulletinBoardData.fileInfo.length
                            ? formData.bulletinBoardData.fileInfo[0].files
                            : []
                        "
                      />
                    </div>
                  </el-row>
                </div>
              </el-form-item>
              <el-form-item label="說明會影片" label-width="100px">
                <div>
                  <el-row>
                    <el-tag
                      type="success"
                      style="height: auto; white-space: break-spaces; font-size: 14px"
                      >說明會影片僅限使用【上傳影片】或貼上【影片連結】其中一種方式使用</el-tag
                    >
                  </el-row>
                  <el-switch
                    style="display: block"
                    v-model="formData.seminarMovieKind"
                    active-color="#409eff"
                    inactive-color="#409eff"
                    active-text="影片連結"
                    inactive-text="上傳影片"
                    :active-value="2"
                    :inactive-value="1"
                  >
                  </el-switch>
                </div>

                <div>
                  <el-row v-show="formData.seminarMovieKind == 1">
                    <UploadCustom
                      :btnStyle="'primary'"
                      ref="uploadRef"
                      :accept="'.mp4'"
                      :payload="formData"
                      :span="24"
                      :data-obj="fileObj"
                      :limit-file-count="1"
                      :limitText="'影片須為.mp4格式，限制不超過2000MB'"
                      :use-drag="false"
                      :action="'TravelSettings/saveGroupTour'"
                      :auto-upload="false"
                      :show-file-list="true"
                      :form-on-loading-parent="formLoading"
                      :btn-txt="'上傳'"
                      :before-file-list="
                        formData.fileInfo && formData.fileInfo.length
                          ? formData.fileInfo[0].files
                          : []
                      "
                    >
                      <!-- <template v-slot:secondButton>
                      <el-button size="mini" type="info" @click="doGetSeminarMovieEvent"
                        >查看</el-button
                      >
                    </template> -->
                    </UploadCustom>
                  </el-row>

                  <el-row v-show="formData.seminarMovieKind == 2">
                    <el-tag
                      type="warning"
                      style="height: auto; white-space: break-spaces; font-size: 14px"
                      >例：https://www.youtube.com/watch?v=i4ZTyJ3dcW8</el-tag
                    >
                    <el-input
                      v-model="formData.seminarMovieLink"
                      placeholder="請輸入影片連結"
                    ></el-input>
                  </el-row>

                  <el-row>
                    <div>
                      <el-button size="mini" type="info" @click="doGetSeminarMovieEvent"
                        >查看紀錄</el-button
                      >
                    </div>
                  </el-row>
                </div>
              </el-form-item>

              <el-form-item label="社群連結" label-width="100px" prop="bulletinBoard">
                <div>
                  <el-row style="display: flex; align-items: center">
                    <el-col :span="13" :lg="18">
                      <el-input
                        class="web-link"
                        placeholder="請輸入官網連結"
                        v-model="formData.official"
                      >
                        <template slot="prepend"><svg-icon icon-class="soical_Icon" /></template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.official"
                          slot="suffix"
                          @click="handleView(formData.official)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                    <el-col :span="10" :lg="5" :offset="1">
                      <el-switch
                        v-model="formData.officialEnable"
                        style="display: block"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        size="mini"
                        active-text="開啟"
                        inactive-text="關閉"
                        :active-value="true"
                        :inactive-value="false"
                        @change="linkChkDefault('official')"
                      >
                      </el-switch>
                    </el-col>
                  </el-row>
                </div>
                <div>
                  <el-row style="display: flex; align-items: center">
                    <el-col :span="13" :lg="18">
                      <el-input
                        class="web-link"
                        placeholder="請輸入Line官方帳號連結"
                        v-model="formData.line"
                      >
                        <template slot="prepend">
                          <svg-icon icon-class="ic_line" />
                        </template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.line"
                          slot="suffix"
                          @click="handleView(formData.line)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                    <el-col :span="10" :lg="5" :offset="1">
                      <el-switch
                        v-model="formData.lineEnable"
                        style="display: block"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="開啟"
                        inactive-text="關閉"
                        :active-value="true"
                        :inactive-value="false"
                        @change="linkChkDefault('line')"
                      >
                      </el-switch>
                    </el-col>
                  </el-row>
                </div>

                <div>
                  <el-row style="display: flex; align-items: center">
                    <el-col :span="13" :lg="18">
                      <el-input
                        class="web-link"
                        placeholder="請輸入FB粉絲團連結。"
                        v-model="formData.fb"
                      >
                        <template slot="prepend">
                          <svg-icon icon-class="ic_facebook" />
                        </template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.fb"
                          slot="suffix"
                          @click="handleView(formData.fb)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                    <el-col :span="10" :lg="5" :offset="1">
                      <el-switch
                        v-model="formData.fbEnable"
                        style="display: block"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="開啟"
                        inactive-text="關閉"
                        :active-value="true"
                        :inactive-value="false"
                        @change="linkChkDefault('fb')"
                      >
                      </el-switch>
                    </el-col>
                  </el-row>
                </div>

                <div>
                  <el-row style="display: flex; align-items: center">
                    <el-col :span="13" :lg="18">
                      <el-input class="web-link" placeholder="請輸入IG連結" v-model="formData.ig">
                        <template slot="prepend">
                          <svg-icon icon-class="ic_ig" />
                        </template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.ig"
                          slot="suffix"
                          @click="handleView(formData.ig)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                    <el-col :span="10" :lg="5" :offset="1">
                      <el-switch
                        v-model="formData.igEnable"
                        style="display: block"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="開啟"
                        inactive-text="關閉"
                        :active-value="true"
                        :inactive-value="false"
                        @change="linkChkDefault('ig')"
                      >
                      </el-switch>
                    </el-col>
                  </el-row>
                </div>

                <div>
                  <el-row style="display: flex; align-items: center">
                    <el-col :span="13" :lg="18">
                      <el-input
                        class="web-link"
                        placeholder="請輸入Youtube連結"
                        v-model="formData.yt"
                      >
                        <template slot="prepend">
                          <svg-icon icon-class="ic_youtube" />
                        </template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.yt"
                          slot="suffix"
                          @click="handleView(formData.yt)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                    <el-col :span="10" :lg="5" :offset="1">
                      <el-switch
                        v-model="formData.ytEnable"
                        style="display: block"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="開啟"
                        inactive-text="關閉"
                        :active-value="true"
                        :inactive-value="false"
                        @change="linkChkDefault('yt')"
                      >
                      </el-switch>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
              <div>
                <el-form-item label="App預覽" label-width="100px" prop="bulletinBoard">
                  <el-select
                    :disabled="permissionCheck(formData.status)"
                    style="margin: 5px; width: 100%"
                    multiple
                    v-if="demoAccounts"
                    filterable
                    clearable
                    placeholder="請選擇可預覽的帳號"
                    v-model="formData.demoAccounts"
                  >
                    <el-option
                      v-for="item in demoAccounts"
                      :key="item.id"
                      :label="`${item.account}-${item.name}`"
                      :value="item.id"
                    />
                  </el-select>

                  <el-tag type="success"
                    >將後台帳號設定於此團，即可用此帳號輸入至APP姓名欄位並登入預覽。</el-tag
                  >
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </el-card>

      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="!permissionCheck(formData.status)"
          type="warning"
          @click="saveData('dynamicValidateForm')"
          :disabled="formLoading"
          style="color: #4b4b4b"
          >儲 存</el-button
        >

        <el-button
          :type="permissionCheck(formData.status) ? 'danger' : ''"
          @click="dialogFormVisible = false"
          >{{ `${permissionCheck(formData.status) ? '關 閉' : '取 消'}` }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 領隊資料檢視 -->
    <el-dialog
      @opened="leaderViewOpenedHandle"
      top="2%"
      append-to-body
      :title="`【${travelName}】領隊資料檢視`"
      :visible.sync="dialogLeaderViewVisible"
      width="70%"
    >
      <leader-data
        v-if="dialogLeaderViewVisible"
        style="height: calc(100vh - 210px); overflow-y: auto"
        :fatherDialogFormVisible="leaderViewdialog"
        :userID="parseInt(selectedLeaderUserID)"
      ></leader-data>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogLeaderViewVisible = false">關 閉</el-button>
      </span>
    </el-dialog>
    <!-- 領隊設定 -->
    <el-dialog
      :title="`【${travelName}】領隊設定`"
      :visible.sync="dialogLeaderFormVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-card v-loading="leaderSettingLoading">
        <el-row v-if="!addLeaderTrigger" style="margin-bottom: 10px">
          <div>
            <el-select
              :disabled="permissionCheck(formData.status)"
              v-model="selectedLeaderUserID"
              filterable
              placeholder="請選擇"
            >
              <el-option
                v-for="item in leaderList"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              />
            </el-select>

            <el-button type="info" style="margin-left: 10px" @click="viewTourLeader"
              >查看領隊資料</el-button
            >
            <el-button
              v-if="selectedLeaderUserID"
              type="success"
              style="margin-left: 10px"
              @click="getLeaderLoginDetails"
              >查看登入明細</el-button
            >
            <el-button
              v-if="!permissionCheck(formData.status)"
              type="warning"
              style="margin-left: 10px"
              @click="addLeaderTrigger = true"
              >新增</el-button
            >

            <!-- <el-switch
              style="margin-left: 10px"
              v-model="addLeaderTrigger"
              active-text="建立領隊"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch> -->
          </div>
        </el-row>
        <el-row v-if="addLeaderTrigger">
          <el-alert
            style="background-color: #ffd643; color: #4b4b4b"
            title="新增領隊系統將以西元生日為預設密碼，ex:19880101"
            type="success"
            effect="dark"
            :closable="false"
          ></el-alert>

          <el-form :model="leaderSimpleForm" ref="addLeaderForm" style="margin-top: 10px">
            <el-form-item
              label="領隊姓名"
              :label-width="formLabelWidth"
              prop="name"
              :rules="[
                {
                  required: true,
                  message: '請輸入領隊姓名',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="leaderSimpleForm.name" autocomplete="off" />
            </el-form-item>

            <el-form-item
              label="領隊生日"
              :label-width="formLabelWidth"
              prop="birthday"
              :rules="[
                {
                  required: true,
                  message: '請輸入領隊生日',
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                style="width: 100%"
                v-model="leaderSimpleForm.birthday"
                type="date"
                placeholder="請選擇領隊生日"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item
              label="領隊電話"
              :label-width="formLabelWidth"
              prop="mobile"
              :rules="[
                {
                  required: true,
                  message: '請輸入領隊電話',
                  trigger: 'blur',
                },
                {
                  required: true,
                  pattern: pattern.mobile,
                  message: '電話格式不正確',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="leaderSimpleForm.mobile" autocomplete="off" />
            </el-form-item>
          </el-form>
        </el-row>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <template v-if="!addLeaderTrigger">
          <el-button
            v-if="!permissionCheck(formData.status)"
            type="warning"
            @click="setTourLeader"
            style="color: #4b4b4b"
            >儲存</el-button
          >

          <el-button
            :type="!permissionCheck(formData.status) ? '' : 'danger'"
            @click="dialogLeaderFormVisible = false"
            >{{ !permissionCheck(formData.status) ? '取消' : '關閉' }}</el-button
          >
        </template>
        <template v-else>
          <el-button type="warning" @click="AddLeaderInfo" style="color: #4b4b4b">儲 存</el-button>

          <el-button @click="addLeaderTrigger = false">取 消</el-button>
        </template>
      </span>
    </el-dialog>
    <!-- 旅客設定 -->
    <el-dialog
      :title="`【${travelName}】旅客設定`"
      :visible.sync="dialogTravelersFormVisible"
      width="80%"
      top="2%"
      v-loading="travelerLoading"
      @closed="travelersFormOnClose"
    >
      <el-card
        v-if="dialogTravelersFormVisible"
        v-loading="travelersTableLoading"
        class="full-height"
        style="height: 600px; min-height: 500px"
      >
        <el-alert type="error" effect="dark" style="margin-bottom: 10px" v-if="exlImportErrorMsg">{{
          exlImportErrorMsg
        }}</el-alert>
        <el-form :inline="true" class="filter-form" @submit.prevent.native="getTravelers">
          <el-form-item label="旅客查詢">
            <el-input v-model="travelerQuery.qry" placeholder="輸入旅客名字/電話" />
          </el-form-item>

          <!-- <el-form-item label="名稱查詢">
        <el-select placeholder="輸入名稱">
          <el-option label="区域一" value="shanghai" />
          <el-option label="区域二" value="beijing" />
        </el-select>
      </el-form-item> -->
          <el-button
            type="primary"
            @click="getTravelers"
            icon="el-icon-search"
            circle
            style="margin-top: 8px; margin-left: 5px"
            :disabled="listLoading"
          ></el-button>
          <el-button
            v-if="!permissionCheck(formData.status)"
            type="warning"
            @click="addTravelers"
            circle
            icon="el-icon-plus"
            :disabled="listLoading"
          ></el-button>
          <el-button
            v-if="!permissionCheck(formData.status)"
            style="cursor: pointer"
            :loading="listLoading"
            :type="isEditMode ? 'danger' : 'success'"
            @click="isEditMode = !isEditMode"
            circle
            :icon="isEditMode ? 'el-icon-close' : 'el-icon-edit'"
          ></el-button>
        </el-form>
        <el-form :inline="true">
          <!-- <el-form-item label="匯入類型" v-if="!permissionCheck(formData.status)">
            <div>
              <el-radio-group v-model="travelersImportType" size="mini">
                <el-radio-button :label="1">旅客 + 領隊</el-radio-button>
                <el-radio-button :label="2">旅客</el-radio-button>
                <el-radio-button :label="3">領隊</el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item> -->

          <el-form-item label="檔案" v-if="!permissionCheck(formData.status)">
            <div>
              <Upload
                ref="excelImportRef"
                :accept="'.xls,.xlsx'"
                :payload="formData"
                :data-obj="{ id: 0, type: 'travelersImport', user: '' }"
                :limit-file-count="1"
                :use-drag="false"
                :action="'TravelSettings/importTravelers'"
                :auto-upload="false"
                :show-file-list="true"
                :form-on-loading-parent="formLoading"
                :btn-txt="'選擇Excel檔'"
                :show-limit="false"
                :btn-style="'primary'"
                :before-file-list="[]"
              />
            </div>
          </el-form-item>

          <el-form-item v-if="!permissionCheck(formData.status)">
            <el-button type="danger" size="mini" @click="doImportExcel"> 匯入 </el-button>

            <el-button type="success" size="mini" @click="openUrl"> 下載範例 </el-button>

            <!-- <a
              href="https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/template/exl/tour_travelers_import_temp_ver5.xlsx"
              target="_blank"
              ><el-tag type="success"> 下載範例</el-tag>
            </a> -->
          </el-form-item>
          <!-- <el-form-item v-if="!permissionCheck(formData.status)">
            <el-switch
              v-model="isEditMode"
              active-text="編輯旅客"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch>
          </el-form-item> -->
          <el-form-item v-if="formData.leaderUserName">
            <el-button size="mini" type="info" @click="viewTourLeader">查看領隊資料</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="pdfFiles && pdfFiles.length > 0"
              type="info"
              plain
              size="mini"
              @click="handleDownloadPdf"
            >
              查看總表檔案
            </el-button>
            <el-button
              v-if="pdfFiles && pdfFiles.length > 0 && !permissionCheck(formData.status)"
              type="danger"
              plain
              size="mini"
              @click="handleDeletePdf"
            >
              刪除總表檔案
            </el-button>
          </el-form-item>

          <!-- 上傳總表 -->
          <el-form-item v-if="!permissionCheck(formData.status)">
            <el-row>
              <el-col :span="24">
                <Upload
                  ref="uploadPdfRef"
                  :accept="'.pdf'"
                  :payload="uploadPdf"
                  :data-obj="{ id: 0, type: 'travelersUploadPdf', user: '' }"
                  :limit-file-count="1"
                  :use-drag="false"
                  :action="'TravelSettings/uploadTravelers'"
                  :auto-upload="false"
                  :show-file-list="true"
                  :show-limit="false"
                  :form-on-loading-parent="formLoading"
                  :btn-txt="'上傳總表'"
                  btn-style="text"
                  :before-file-list="[]"
                />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>

        <el-alert
          v-if="!permissionCheck(formData.status)"
          type="success"
          effect="dark"
          style="background-color: #ffd643; color: #4b4b4b; margin-bottom: 10px"
          :closable="false"
        >
          <template slot="title">
            1、帳號相同姓名不相同系統視為多筆帳號<br />
            2、只有持有旅客角色權限才會出現於列表(匯入直接設定角色，調整角色只限ITA管理員)<br />
            3、手動加入之旅客基本資料填寫完畢後請先點擊【加入】才能正確加入旅客<br />
            4，領隊預設使用<span style="color: red">【西元生日】</span
            >當作登入密碼，ex:西元1988-01-01
            預設密碼為：19880101，生日可接受格式：【1911-01-01】、【1911/01/01】
          </template>
        </el-alert>
        <el-alert
          v-else
          type="warning"
          style="background-color: #ffd643; color: #4b4b4b; margin-bottom: 10px"
          :closable="false"
        >
          <template slot="title">
            {{ `旅遊團狀態為：【${formData.statusDesc}】已無法【新增 / 編輯 / 刪除】旅客資料` }}
          </template>
        </el-alert>

        <div class="full-height travelers-div">
          <el-table
            class="travelers-table"
            height="300"
            ref="multipleTable"
            border
            size="mini"
            :data="travelersList"
            tooltip-effect="dark"
            style="width: 100%; position: relative"
            @selection-change="handleSelectionChange"
          >
            <el-table-column align="center" label="項次" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <!-- 新增分組參數 -->
            <el-table-column prop="travelersGroup" label="分組" align="center" width="120">
              <template slot-scope="scope">
                <el-input :disabled="!isEditMode" v-model="scope.row.travelersGroup" />
              </template>
            </el-table-column>
            <!-- 新增身份參數 -->
            <el-table-column prop="travelersIdentity" label="身份" align="center" width="120">
              <template slot-scope="scope">
                <el-input :disabled="!isEditMode" v-model="scope.row.travelersIdentity" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" align="center" width="120">
              <template slot-scope="scope">
                <el-input :disabled="!isEditMode || !!scope.row.userID" v-model="scope.row.name" />
              </template>
            </el-table-column>
            <el-table-column prop="birthDay" label="生日" align="center" width="190">
              <template slot-scope="scope">
                <el-input
                  :disabled="!isEditMode || !!scope.row.userID"
                  v-model.trim="scope.row.birthDay"
                  :maxlength="10"
                ></el-input>
                <!-- <el-date-picker :disabled="!isEditMode" style="width: 100%" v-model="scope.row.birthDay" type="date"
                  placeholder="ex: 1980-01-01" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker> -->
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="電話(非必填)" align="center" width="160">
              <template slot-scope="scope">
                <el-input
                  :disabled="
                    !isEditMode || (!!scope.row.userID && checkHasMobile(scope.row.userID))
                  "
                  v-model="scope.row.mobile"
                />
              </template>
            </el-table-column>
            <el-table-column prop="isMain" label="主要旅客(可登入APP)" align="center" width="140">
              <template slot-scope="scope">
                <el-switch
                  :disabled="!isEditMode"
                  v-model="scope.row.isMain"
                  active-text="是"
                  inactive-text="否"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="true"
                  :inactive-value="false"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="mail" label="EMail (非必填)" align="center" width="200">
              <template slot-scope="scope">
                <el-input :disabled="!isEditMode" v-model="scope.row.mail" />
              </template>
            </el-table-column>
            <!-- <el-table-column label="年齡" align="center" width="120">
              <template slot-scope="scope" v-if="scope.row.age">
                <el-tag v-if="scope.row.age.years > 0"
                  >{{ scope.row.age.years }}歲{{ scope.row.age.months }}個月{{
                    scope.row.age.days
                  }}天</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column
              prop="birthDay"
              label="生日"
              align="center"
              width="120"
              show-overflow-tooltip
            /> -->

            <!-- <el-table-column
              label="狀態"
              align="center"
              width="120"
              show-overflow-tooltip
            >
              <template v-if="scope.row.isJoin != null" slot-scope="scope">
                <el-tag
                  :type="
                    scope.row.isJoin
                      ? 'success'
                      : scope.row.isOtherJoin
                      ? 'warning'
                      : 'danger'
                  "
                >
                  {{
                    scope.row.isJoin
                      ? "已加入"
                      : scope.row.isOtherJoin
                      ? "他團"
                      : "未加入"
                  }}
                </el-tag>
              </template>
            </el-table-column> -->

            <el-table-column
              prop="agencyRemind"
              label="旅行社提醒 (非必填)"
              show-overflow-tooltip
              width="250"
            >
              <template slot-scope="scope">
                <el-input
                  :disabled="!isEditMode"
                  v-model="scope.row.notice.agencyRemind"
                  type="textarea"
                />
              </template>
            </el-table-column>

            <el-table-column
              prop="leaderRemind"
              label="領隊備註 (非必填)"
              show-overflow-tooltip
              width="250"
            >
              <template slot-scope="scope">
                <el-input
                  :disabled="!isEditMode"
                  v-model="scope.row.notice.leaderRemind"
                  type="textarea"
                />
              </template>
            </el-table-column>

            <el-table-column align="center" label="登入/登出次數" width="120">
              <template
                slot-scope="scope"
                v-if="scope.row.loginTimes && scope.row.loginTimes.length > 0"
              >
                <el-tag type="success" size="mini">{{
                  partingLoginTime(scope.row.loginTimes, 1).length
                }}</el-tag
                >/<el-tag type="danger" size="mini">{{
                  partingLoginTime(scope.row.loginTimes, 2).length
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column align="center" label="明細">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.loginTimes && scope.row.loginTimes.length > 0"
                  size="mini"
                  type="info"
                  @click="getLoginDetails(scope.row)"
                  >明細</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="刪除" align="center" v-if="!permissionCheck(formData.status)">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.isJoin"
                  size="mini"
                  :type="
                    partingLoginTime(scope.row.loginTimes || [], 1).length > 0 ? 'info' : 'danger'
                  "
                  @click="deleteTravelers(scope.row.userID, scope.row.name, scope.$index)"
                  :disabled="partingLoginTime(scope.row.loginTimes || [], 1).length > 0"
                >
                  {{
                    partingLoginTime(scope.row.loginTimes || [], 1).length > 0 ? '已使用' : '刪除'
                  }}
                </el-button>
                <!--
                <el-button
                  v-if="!scope.row.isJoin && !scope.row.isOtherJoin"
                  size="mini"
                  type="success"
                  plain
                  @click="setTravelers(scope.row)"
                  >加入</el-button
                > -->
              </template>
            </el-table-column>

            <!-- <el-table-column label="編輯" show-overflow-tooltip width="120">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.isJoin"
                  size="mini"
                  type="primary"
                  plain
                  @click="setTravelers(scope.row)"
                  >儲存</el-button
                >
              </template>
            </el-table-column> -->

            <!-- <el-table-column label="刪除" show-overflow-tooltip width="120">
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.isJoin && !scope.row.isOtherJoin"
                  size="mini"
                  type="danger"
                  plain
                  @click="removeTravelers(scope.row.userID, scope.row.name)"
                  >刪除</el-button
                >
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="warning"
          @click="setTravelers"
          :disabled="travelersTableLoading"
          v-if="!permissionCheck(formData.status)"
          style="color: #4b4b4b"
          >儲 存</el-button
        >

        <el-button
          @click="dialogTravelersFormVisible = false"
          :type="!permissionCheck(formData.status) ? '' : 'danger'"
          >{{ !permissionCheck(formData.status) ? '取 消' : '關 閉' }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 行程設定 -->
    <el-dialog
      v-loading="listLoading"
      :title="`【${travelName}】行程設定`"
      :visible.sync="dialogPlanningFormVisible"
      fullscreen
      top="2%"
      @closed="onPlanningDialogClosed"
    >
      <el-card v-loading="planningSettingLoading">
        <!--<el-form :inline="true" style="height: 60px">
            <el-form-item>
              <span>{{ travelName }}</span>
            </el-form-item>
            <el-form-item>

            </el-form-item>
          </el-form>-->
        <div style="margin-bottom: 10px; display: flex; align-items: flex-end; gap: 0 10px">
          <el-button
            v-if="planningData && planningData.thisTime.data.length == 0"
            size="mini"
            type="success"
            @click="refreshItinerary"
            >重新整理</el-button
          >
          <el-button size="mini" type="danger" @click="handleNoticeDialog">注意事項</el-button>
          <div style="position: relative">
            <Upload
              class="manual"
              ref="uploadHandbookRef"
              :accept="'.pdf'"
              :payload="planningData"
              :data-obj="fileObj"
              :limit-file-count="1"
              :use-drag="false"
              :limitText="'檔案須為.pdf格式，限制不超過2000MB'"
              :action="'TravelSettings/tourHandbook'"
              :auto-upload="false"
              :show-file-list="true"
              :form-on-loading-parent="formLoading"
              :btn-txt="'上傳手冊'"
              :before-file-list="
                formData.handbook && formData.handbook.length ? formData.handbook[0].files : []
              "
            />
          </div>
        </div>

        <el-tabs v-model="planningTab" type="border-card">
          <el-tab-pane label="行程規劃" name="thisDays">
            <!--            <el-button v-show="!permissionCheck(formData.status)" type="warning" @click="addNewPlanning" size="mini"-->
            <!--              style="margin-bottom: 10px">新增</el-button>-->
            <div style="max-height: calc(100vh - 350px); overflow: auto">
              <el-form
                v-for="(item, index) in planningData.thisTime.data"
                :key="index"
                :inline="true"
                class="demo-form-inline"
              >
                <el-form-item label="">
                  <el-tag>Day{{ index + 1 }}</el-tag>
                </el-form-item>
                <el-form-item label="區域" v-show="checkPermission(['ITA-DEV'])">
                  <el-select
                    v-if="item.regions"
                    v-model="item.region"
                    value-key="key"
                    placeholder="區域"
                    size="mini"
                    style="width: 100px"
                    @change="selectedRegion(item)"
                  >
                    <el-option
                      v-for="(c, ind) in item.regions"
                      :key="ind"
                      :label="c.val"
                      :value="c.key"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item label="國家" v-show="checkPermission(['ITA-DEV'])">
                  <el-select
                    v-if="item.countries"
                    v-model="item.country"
                    v-loading="item.countriesLoading"
                    filterable
                    placeholder="國家"
                    value-key="code"
                    size="mini"
                    style="width: 100px"
                    @change="selectedCountry(item)"
                  >
                    <el-option
                      v-for="(c, ind) in item.countries"
                      :key="ind"
                      :label="c.chtName"
                      :value="c"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item label="城市" v-show="checkPermission(['ITA-DEV'])">
                  <el-select
                    v-if="item.cities"
                    v-model="item.city"
                    v-loading="item.countriesLoading || item.citiesLoading"
                    clearable
                    filterable
                    placeholder="城市"
                    value-key="code"
                    size="mini"
                    style="width: 120px"
                    @change="selectedCity(item)"
                  >
                    <el-option
                      v-for="(c, ind) in item.cities"
                      :key="ind"
                      :label="c.chtName"
                      :value="c"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item label="經緯度(lng,lat)" v-show="checkPermission(['ITA-DEV'])">
                  <el-col class="line" :span="12">
                    <el-input v-model="item.lng" placeholder="經度(lng)" />
                  </el-col>
                  <el-col class="line" :span="12">
                    <el-input v-model="item.lat" placeholder="緯度(lat)" />
                  </el-col>
                </el-form-item>

                <el-form-item label="行程說明" style="width: 90%" class="widh-input">
                  <el-col class="line" :span="24">
                    <el-input
                      type="textarea"
                      :rows="6"
                      resize="none"
                      v-model="item.description"
                      style="width: 100%"
                      placeholder="行程說明"
                    />
                  </el-col>
                </el-form-item>

                <el-form-item
                  label="當日餐食"
                  style="width: 90%; padding-left: 4.3em"
                  class="widh-input"
                >
                  <el-col class="line" :span="24">
                    <el-input
                      v-model="item.food"
                      style="width: 106.3%"
                      placeholder="ex: 早餐： 飯店 /中午：日式定食 /晚餐：燒肉套餐"
                    />
                  </el-col>
                </el-form-item>

                <el-form-item
                  label="住宿旅館"
                  style="width: 90%; padding-left: 4.3em"
                  class="widh-input"
                >
                  <el-col class="line" :span="24">
                    <el-input
                      v-model="item.hotelName"
                      style="width: 106.3%"
                      placeholder="住宿旅館"
                    />
                  </el-col>
                </el-form-item>

                <el-form-item>
                  <el-button type="success" size="mini" @click="handleEditPlanDialog(index + 1)">
                    {{ permissionCheck(formData.status) ? '查看' : '編輯' }}
                  </el-button>
                  <el-button
                    type="info"
                    @click="getTravelPositionRecord(index + 1, item.description)"
                    size="mini"
                    >足跡</el-button
                  >
                  <el-button
                    v-show="!isProdMode"
                    type="info"
                    @click="getTravelPositionRecordForTest(index + 1, item.description)"
                    size="mini"
                    >足跡(測試資料)</el-button
                  >
                  <!-- <el-button v-show="!permissionCheck(formData.status)" type="danger" @click="deletePlanning(item)"
                    size="mini">刪除</el-button> -->
                </el-form-item>

                <!-- <el-form-item>
                  <el-button
                    type="success"
                    @click="eidtPassPoint(item, index + 1)"
                    >添加經過點</el-button
                  >

                  <el-dialog
                    :append-to-body="true"
                    title="添加經過點"
                    :visible.sync="item.passPointDialogVisible"
                    width="80%"
                    top="2%"
                    center
                  >
                    <pass-point
                      :regions="regionsSource"
                      :travel-num="selectedTravelID"
                      :day="index + 1"
                    />

                    <span slot="footer" class="dialog-footer">
                      <el-button @click="item.passPointDialogVisible = false"
                        >關閉</el-button
                      >
                    </span>
                  </el-dialog>
                </el-form-item> -->
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="精彩行程" name="thisTimes" v-if="false">
            <el-col :span="24">
              <el-form ref="form" label-width="130px" label-position="right">
                <!-- <el-form-item label="出發時間">
                  <el-time-select
                    v-model="planningData.theDay.departureTime"
                    :picker-options="{
                      start: '08:00',
                      step: '00:10',
                      end: '23:30',
                    }"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="出發時間"
                  >
                  </el-time-select>
                </el-form-item> -->
                <!-- <el-form-item label="出發集合地點">
                  <el-input v-model="planningData.theDay.assemblingPlace" />
                </el-form-item> -->
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="上午景點">
                      <el-input v-model="planningData.theDay.morningSights" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="早餐">
                      <el-input v-model="planningData.theDay.breakfast" />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="下午景點">
                      <el-input v-model="planningData.theDay.afternoonAttractions" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="午餐">
                      <el-input v-model="planningData.theDay.lunch" />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="晚間景點">
                      <el-input v-model="planningData.theDay.eveningAttractions" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="晚餐">
                      <el-input v-model="planningData.theDay.dinner" />
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <el-form-item label="旅館名稱">
                  <el-input v-model="planningData.theDay.hotelName" />
                </el-form-item> -->

                <!-- <el-form-item label="預計返回旅館時間">
                  <el-time-select
                    v-model="planningData.theDay.returnHotelTime"
                    :picker-options="{
                      start: '08:00',
                      step: '00:10',
                      end: '23:30',
                    }"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="預計返回旅館時間"
                  >
                  </el-time-select>
                </el-form-item> -->

                <el-form-item label="本日行程注意事項">
                  <el-input v-model="planningData.theDay.notesOnToday" />
                </el-form-item>
              </el-form>
            </el-col>
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button
          v-show="!permissionCheck(formData.status)"
          type="warning"
          @click="planningSettingSave"
          style="color: #4b4b4b"
          >儲 存</el-button
        >

        <el-button @click="dialogPlanningFormVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 注意事項設定 -->
    <el-dialog
      :title="`【${travelName}】注意事項`"
      :visible.sync="noticeSettingVisible"
      width="90%"
      :close-on-click-modal="false"
      :before-close="handleClearNotice"
    >
      <el-alert
        title="為了給旅客APP更好的呈現效果，建議字型大小設定為36pt以上。"
        type="warning"
        effect="dark"
        :closable="false"
        style="color: #4b4b4b; margin-bottom: 10px"
      >
      </el-alert>
      <el-card v-loading="noticeSettingLoading" v-if="noticeSettingVisible">
        <tinymce
          :id="`tinymceNotice_${selectedTravelID}`"
          v-model="noticeContent"
          :ref="`tinymceNotice_${selectedTravelID}`"
          :height="300"
          :type="27"
        />
      </el-card>
      <template slot="footer" class="dialog-footer">
        <el-button
          v-show="!permissionCheck(formData.status)"
          @click="handleSetNotice"
          type="warning"
          :loading="noticeSettingLoading"
          style="color: #4b4b4b"
          >儲 存</el-button
        >
        <el-button
          :type="!permissionCheck(formData.status) ? '' : 'danger'"
          @click="handleCancelNotice"
        >
          {{ !permissionCheck(formData.status) ? '取消' : '關閉' }}
        </el-button>
      </template>
    </el-dialog>

    <!-- 編輯行程設定 -->
    <el-dialog
      :title="`【${travelName}】編輯行程內容 Day${planDay}`"
      :visible.sync="planSettingVisible"
      width="90%"
      :close-on-click-modal="false"
      :before-close="handleClearPlan"
    >
      <el-alert
        title="為了給旅客APP更好的呈現效果，建議字型大小設定為36pt以上。"
        type="warning"
        effect="dark"
        :closable="false"
        style="color: #4b4b4b; margin-bottom: 10px"
      >
      </el-alert>
      <el-card v-loading="planSettingLoading" v-if="planSettingVisible">
        <tinymce
          v-model="planContent"
          :id="`tinymcePlan_${planDay}_${selectedTravelID}`"
          :ref="`tinymcePlan_${planDay}_${selectedTravelID}`"
          :height="300"
          :type="27"
        />
      </el-card>
      <template slot="footer" class="dialog-footer">
        <el-button
          v-show="!permissionCheck(formData.status)"
          @click="handleSetPlan"
          type="warning"
          :loading="planSettingLoading"
          style="color: #4b4b4b"
          >儲 存</el-button
        >
        <el-button
          :type="!permissionCheck(formData.status) ? '' : 'danger'"
          @click="planSettingVisible = false"
        >
          {{ !permissionCheck(formData.status) ? '取消' : '關閉' }}
        </el-button>
      </template>
    </el-dialog>

    <!-- 複製多團設定 -->
    <el-dialog
      :title="`【${duplicateTravelFormData.travelName}】複製多團設定`"
      :visible.sync="dialogDuplicateMultipleTravelVisible"
      width="80%"
      top="2%"
      v-loading="duplicateMultipleTravelLoading"
      @closed="dialogDuplicateMultipleTravelOnClose"
    >
      <el-alert type="error" style="margin-bottom: 10px" :closable="false">
        <p style="line-height: 1.8rem; font-size: 15px">
          複製新的旅遊團耗時較久請耐心等待，視原始團檔案大小而定。<br />
          複製項目：1、旅遊團基本資料 2、每日行程資料 3、攜帶物品資料<br />
          複製完畢後，請另行設定：1、領隊及旅客匯入、分組、安排座位 2、上傳旅遊手冊、上傳說明會影片
        </p>
      </el-alert>
      <el-table
        height="300"
        ref="multipleCopyTable"
        border
        size="mini"
        :data="duplicateTableFormData.tableData"
        tooltip-effect="dark"
        style="width: 100%; position: relative"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!-- 複製團號 -->
        <el-table-column prop="tourGroupNo" label="團號" align="center" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.tourGroupNo" clearable />
          </template>
        </el-table-column>
        <!-- 行程日期區間 -->
        <el-table-column prop="beginDate" label="行程日期區間" align="center" width="380">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerBeginDateLimitOptions"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <!-- 集合出發時間 -->
        <el-table-column prop="beginTime" label="集合出發時間" align="center" width="160">
          <template slot-scope="scope">
            <el-time-select
              :clearable="false"
              @change=""
              style="width: 100%; font-size: 12px"
              v-model="scope.row.beginTime"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:45',
              }"
              placeholder="選擇時間"
            />
          </template>
        </el-table-column>
        <!-- 行程結束時間 -->
        <el-table-column prop="endTime" label="行程結束時間" align="center" width="160">
          <template slot-scope="scope">
            <el-time-select
              :clearable="false"
              style="width: 100%; font-size: 12px"
              v-model="scope.row.endTime"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:45',
              }"
              placeholder="選擇時間"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: space-between">
              <el-button
                size="small"
                plain
                @click="handleDeleteNewCopyRow(scope.row)"
                circle
                icon="el-icon-delete"
              ></el-button>
              <el-button
                size="small"
                plain
                type="primary"
                v-show="scope.$index + 1 === duplicateTableFormData.tableData.length"
                @click="handleAddNewCopyRow(scope.row)"
                circle
                icon="el-icon-plus"
              ></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="warning"
          style="margin-left: 5px; color: #4b4b4b"
          @click="saveDuplicateMultipleTravel"
          >儲 存</el-button
        >
        <el-button @click="dialogDuplicateMultipleTravelVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="複製多團設定結果"
      :visible.sync="dialogDuplicateMultipleTravelResultVisible"
      @closed="dialogDuplicateMultipleTravelResultOnClose"
    >
      <el-card class="box-card">
        <div>
          <div style="position: relative; height: 400px">
            <el-table
              v-loading="showDownloadLoading"
              size="mini"
              :data="duplicateMultipleTravelResult"
              border
              fit
              highlight-current-row
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="成功團號">
                <template slot-scope="scope">
                  <el-tag type="success" effect="plain" v-if="scope.row.type == 'success'">
                    {{ `${scope.row.group}` }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="失敗團號">
                <template slot-scope="scope">
                  <el-tag type="danger" effect="plain" v-if="scope.row.type == 'fail'">
                    {{ `${scope.row.group}` }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDuplicateMultipleTravelResultVisible = false">確 認</el-button>
      </span>
    </el-dialog>

    <!-- 報名列表 -->
    <el-dialog
      title="報名介紹"
      :visible.sync="signUpTravelDialogVisible"
      width="40%"
      append-to-body
    >
      <el-input
        type="textarea"
        :rows="8"
        v-model="signUpNotice"
        placeholder="請輸入報名介紹內容"
        style="width: 100%"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="signUpTravel">儲 存</el-button>
        <el-button @click="signUpTravelDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-form :inline="true" class="filter-form">
      <el-form-item
        label="旅行社"
        v-if="checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF'])"
      >
        <el-select v-model="listQuery.agencyCode" filterable placeholder="請選擇旅行社" clearable>
          <el-option
            v-for="item in agencyList"
            :key="item.key"
            :label="item.val"
            :value="item.key"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        label="目的地"
        style="width: 300px; height: 47px"
        class="listquery-target-point"
      >
        <div class="block" style="width: 100%">
          <el-cascader
            popper-class="travel-data-cascader"
            @change="getPositionAndCouurncy()"
            clearable
            collapse-tags
            v-model="listQuery.countryArea"
            :props="{
              multiple: true,
              checkStrictly: false,
              expandTrigger: 'hover',
            }"
            style="width: 100%; top: 16px; top: 0px"
            placeholder="請選擇"
            filterable
            :options="travelAttractionsMenu"
          >
          </el-cascader>
        </div>
      </el-form-item>

      <el-form-item label="團號">
        <el-input v-model="listQuery.qry" placeholder="輸入團號" />
      </el-form-item>

      <el-form-item label="團名">
        <el-input v-model="listQuery.qrySecond" placeholder="輸入團名" />
      </el-form-item>

      <el-form-item label="出發區間" style="width: 250px">
        <el-date-picker
          v-model="listQuery.dateFilter"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="開始日期"
          end-placeholder="結束日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        >
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="人數" style="width: 110px">
        <el-input-number
          style="width: 100%"
          v-model="listQuery.memberCount"
          controls-position="right"
          :min="1"
          :max="50"
        ></el-input-number>
      </el-form-item> -->

      <el-form-item label="旅遊性質" style="width: 180px">
        <el-select clearable v-model="listQuery.travelProperty" filterable placeholder="請選擇">
          <el-option
            v-for="item in travelPropertyOption"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="狀態" style="width: 180px">
        <el-select clearable v-model="listQuery.status" filterable placeholder="請選擇狀態">
          <el-option
            v-for="item in travelStatusOption"
            :key="item.key"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        label="旅客查詢"
        v-if="checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF'])"
      >
        <el-input
          placeholder="輸入旅客姓名"
          style="width: 100%"
          v-model="listQuery.memberQry"
        ></el-input>
      </el-form-item>

      <el-button
        type="primary"
        @click="getList"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        type="warning"
        @click="addData"
        circle
        icon="el-icon-plus"
        :disabled="listLoading"
      ></el-button>
      <!-- AI -->
      <!-- <el-button
        type="warning"
        @click="dialogTravelChoiceVisible = true"
        circle
        icon="el-icon-plus"
        :disabled="listLoading"
      ></el-button> -->
      <!-- <el-button
        style="cursor: pointer"
        v-loading="listLoading"
        type="success"
        icon="el-icon-refresh-left"
        circle
        @click="refresh()"
      ></el-button> -->
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>

      <!-- <el-button style="cursor: pointer" type="success" :loading="listLoading"
        @click="editTravelInfoAnalyticsForm()">AI智能</el-button> -->
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60" fixed="left">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="團號"
          width="160"
          fixed="left"
          :fixed="device !== 'mobile' ? 'left' : null"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.tourGroupNo }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="出團日" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.beginDate }}</span>
          </template>
        </el-table-column> -->

        <el-table-column
          v-if="checkPermission(['ITA-DEV', 'ITA-ADMIN'])"
          align="center"
          label="團ID"
          width="50"
          fixed="left"
          :fixed="device !== 'mobile' ? 'left' : null"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="團名"
          width="200"
          fixed="left"
          :fixed="device !== 'mobile' ? 'left' : null"
        >
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
            <div>
              <div>
                <el-tag style="font-size: 14px">
                  出發
                  <span style="color: red">{{ `${row.beginDate} ${row.beginTime}` }}</span>
                  <br />
                  回程
                  <span style="color: red">{{ `${row.endDate} ${row.endTime}` }}</span>
                </el-tag>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="狀態" width="110">
          <template slot-scope="scope">
            <el-tag :type="statusTranslateStyle(scope.row.status)">{{
              scope.row.statusDesc
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅行社代碼" width="100" v-if="!agencyCode">
          <template slot-scope="{ row }">
            <span>{{ row.agencyCode }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅行社名稱" width="100" v-if="!agencyCode">
          <template slot-scope="{ row }">
            <span>{{ row.agencyName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              :type="permissionCheck(scope.row.status) ? 'info' : 'success'"
              @click="editData(scope.row)"
              >{{ `${permissionCheck(scope.row.status) ? '查看' : '編輯'}` }}</el-button
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="網卡購買" width="150">
          <template slot-scope="{ row }">
            <div v-loading="row.networkSettingLoading">
              <el-button
                v-if="row.networkCardStatus"
                size="mini"
                type="warning"
                @click="setTravelNetworkCard(row)"
                >網卡購買　{{ row.networkCard ? `(${row.networkCard.cardCount})` : '' }}</el-button
              >
              <template v-else>
                <el-button
                  size="mini"
                  type="info"
                  @click="setTravelNetworkCard(row)"
                  v-if="
                    row.networkCard && row.networkCard.cardCount && row.networkCard.cardCount > 0
                  "
                  >查看 {{ row.networkCard ? `(${row.networkCard.cardCount})` : '' }}</el-button
                >
              </template>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅客設定" width="150">
          <template slot-scope="scope">
            <el-button size="mini" plain @click="editTravelers(scope.row)"
              >旅客設定　{{
                scope.row.touristCount ? `(${scope.row.touristCount})` : ''
              }}</el-button
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="領隊設定" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-if="scope.row.leaderUserName"
              type="primary"
              plain
              @click="leaderSetting(scope.row)"
              >{{ scope.row.leaderUserName }}</el-button
            >

            <el-button v-else type="primary" size="mini" @click="leaderSetting(scope.row)"
              >領隊設定</el-button
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="行程設定" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              plain
              @click="getItineraryPlanningSetting(scope.row)"
              >行程設定</el-button
            >
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="常用表單維護" width="130">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              @click="editCommonForms(scope.row)"
              >常用表單維護</el-button
            >
          </template>
        </el-table-column> -->

        <el-table-column align="center" label="座位設定" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="info" plain @click="editSeatForms(scope.row)"
              >座位設定</el-button
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="攜帶物品" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" plain @click="getCarryItemsSetting(scope.row)"
              >攜帶物品</el-button
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="複製旅遊團" width="100">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="duplicateMultipleTravel(scope.row)"
              >複製</el-button
            >
            <!-- <el-button type="warning" size="mini" @click="duplicateTravel(scope.row)">複製</el-button> -->
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="刪除旅遊團"
          width="100"
          v-if="checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF'])"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteTravel(scope.row)">刪除</el-button>
          </template>
        </el-table-column>

        <el-table-column
          prop="description"
          label="日期登入"
          width="150"
          align="center"
          v-if="checkPermission(['ITA-DEV', 'ITA-ADMIN', 'SERVICE-ADMIN', 'ITA-SALES'])"
        >
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              @click="opLoginDateSetting(scope.row)"
              style="margin-right: 5px"
              >日期登入</el-button
            >
            <el-tag v-if="scope.row.useDateLogin && scope.row.loginDateStr">{{
              scope.row.loginDateStr
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="報名連結" width="200">
          <template slot-scope="scope">
            <!-- <div v-loading="scope.row.networkSettingLoading"> -->
            <el-button
              v-if="!scope.row.signUpUrl && scope.row.status < 2"
              size="mini"
              type="info"
              @click="openSignUpTravelDialog(scope.row)"
              >建立連結</el-button
            >
            <template v-else>
              <!-- <span>{{ scope.row.signUpUrl }}</span> -->
              <a
                :href="scope.row.signUpUrl"
                target="_blank"
                style="
                  color: #409eff;
                  text-decoration: underline;
                  display: inline-block;
                  margin-bottom: 5px;
                "
              >
                {{ scope.row.signUpUrl }}
              </a>
              <br />
              <el-button
                v-if="scope.row.status < 2"
                size="mini"
                type="info"
                @click="openSignUpTravelDialog(scope.row)"
                >編輯介紹</el-button
              >
            </template>
            <!-- </div> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Map from '@/components/Map/Map.vue' // Secondary package based on el-pagination
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import CouponData from '@/views/ita/appManage/components/couponData.vue'
import CouponList from '@/views/ita/travel/components/couponList.vue'
import Tinymce from '@/components/TinymceForApp'
import { mapGetters } from 'vuex'
import { getEditPage, saveEditPage } from '@/api/tcSetting'
import { getCouponLoopCategoryOptions, getDefaultCoupon } from '@/api/coupon'
import checkPermission from '@/utils/permission' // 权限判断函数
import { convertFileToBase64 } from '@/utils/funcs'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)
import { getAgencyMemberFilterCountiesList, saveDemoAccounts } from '@/api/member'

import {
  getAgencyTravelsAndOtherInformation,
  copyTravelCarryItems,
  getAgencyAnSocialNetworkingLink,
  getAgencySocialNetworkingLink,
  saveTourLeaderInfo,
} from '@/api/agency'

import {
  saveGroupTourCommonForms,
  importTravelers,
  parseTravelersExcel,
  uploadTravelers,
  getGroupTourList,
  saveGroupTour,
  getAgencyOptions,
  getTourLeaders,
  setTourLeader,
  getTravelers,
  setTravelers,
  deleteTravelers,
  removeTravelers,
  getItineraryPlanningSetting,
  getCountryRegions,
  getCountriesByRegion,
  getCitiesByCountryCode,
  saveItineraryPlanningSetting,
  getTravelCoupons,
  switchTravelCouponShowToSurvey,
  deleteTravelCoupon,
  getCarryItemsSetting,
  settingCarryItems,
  getTravelAttractionsCascaderMenu,
  saveTravelNetworkSetting,
  getAgencyCouponsOption,
  getCurrencyOptions,
  getNetworkCardOptions,
  getTravelNetworkSetting,
  getCurrenciesByCountries,
  deleteTravel,
  duplicateTravel,
  getTravelPositionRecord,
  getCurrentNetworkCardPostFee,
  gePositionByCountries,
  getTravelLeaderUserID,
  getTravelStatus,
  duplicateTravelList, // 複製多個旅行團
  getLeaderLoginRecord,
  travelInfoAnalytics,
  refreshItinerary,
  getSeminarMovieEvent,
  saveLoginDate,
  getLoginDate,
  getTravelBulletinBoard,
  createSignUpUrl,
} from '@/api/travel'
import { MessageBox, Message } from 'element-ui'
import { defineDocExtension } from 'codemirror'
import { verifyEmail } from '@/utils/validate'
import { date } from 'jszip/lib/defaults'

var defaultForm = {
  id: null,
  loginDateEnable: false,
  loginDate: '',
  demoAccounts: [],
  tourGroupNo: '',
  travelName: '',
  fileInfo: [],
  commonForms: [],
  showTravelInfo: true,
  agencyCode: '',
  countryAreaList: [],
  departureDate: '',
  departureTime: '',
  returnDate: '',
  returnTime: '',
  memberCount: 0,
  travelProperty: 1,
  travelAttributes: null,
  // networkCard: false,
  // networkCardCount: 0,
  networkSettingLoading: false,
  coupon: { fileInfo: [] },
  currency: null,
  official: null,
  officialEnable: false,
  fb: null,
  fbEnable: false,
  line: null,
  lineEnable: false,
  ig: null,
  igEnable: false,
  yt: null,
  ytEnable: false,
  position: [],
  seminarMovieKind: 1,
  gatherAroundLocation: null,
  bulletinBoardData: { fileInfo: [] },
  signUpUrl: '',
}

var defaultTravelers = {
  userID: 0,
  name: null,
  mobile: null,
  travelersGroup: null,
  travelersIdentity: null,
  birthDay: null,
  account: null,
  age: {
    years: 0,
    months: 0,
    days: 0,
  },
  isJoin: true,
  isMain: true,
  isOtherJoin: false,
  notice: {
    agencyRemind: null,
    leaderRemind: null,
  },
  avatar: null,
}
var defaultCouponForm = {
  id: null,
  couponPhone: null,
  couponName: null,
  title: null,
  position: null,
  description: null,
  link: null,
  sort: null,
  couponCategories: [{ sort: 1, selected: null }],
  fileInfo: {},
  beginDate: '',
  endDate: '',
  showToSurvey: false,
}
var defaultCopyMultipleTraveler = {
  tourGroupNo: null,
  beginDate: null,
  beginTime: null,
  endDate: null,
  endTime: null,
}
export default {
  components: {
    Map,
    Tinymce,
    Pagination,
    CouponData,
    CouponList,
    Upload: () => import('@/views/ita/components/fileUpload.vue'),
    passPoint: () => import('@/views/ita/travel/components/passPointComponents.vue'),
    Seat: () => import('@/views/ita/travel/components/seatComponents.vue'),
    SeatSecond: () => import('@/views/ita/travel/components/seatBackComponents.vue'),
    LeaderData: () => import('@/views/ita/components/leaderViewData.vue'),
    UploadCustom: () => import('@/views/ita/components/fileUploadCustom.vue'),
    TravelBulletinBoard: () => import('@/views/ita/components/TravelBulletinBoard.vue'),
  },
  filters: {},
  computed: {
    ...mapGetters(['userInfo', 'device', 'showDownloadLoading']),
  },
  destroyed() {
    // console.log("tourGroupDataTable 被銷毀了");
  },
  deactivated() {
    // console.log("tourGroupDataTable被停用了");
  },
  activated() {
    // console.log("tourGroupDataTable 被激活了");
  },
  watch: {
    'selectedNetworkRow.networkCard': {
      handler: function (newVal, oldVal) {
        let vm = this
        if (!newVal) {
          vm.currentNetworkDesc = ''
        } else {
          if (vm.selectedNetworkRow.cardID) {
            let find = vm.selectedNetworkRow.networkOptions.filter(f => {
              return f.key == vm.selectedNetworkRow.cardID
            })

            if (find && find.length > 0) {
              vm.currentNetworkDesc = find[0].desc
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    'formData.countryAreaList': {
      handler: async function (newVal, oldVal) {
        let vm = this
        this.selectedTaiwan = newVal.some(x => x == 'region_10') ? true : false
        if (newVal.length > 0) {
          //預覽帳號
          await vm.getAgencyMemberFilterCountiesList()
        } else {
          vm.demoAccounts = []
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      signUpTravelDialogVisible: false,
      signUpNotice: '',
      currentTravelId: null,
      bulletinList: [],
      dialogTravelBulletinBoardVisible: false,
      dialogLoginDateVisible: false,
      travelSeminarMovieEventVisible: false,
      travelSeminarMovieEvent: [],
      boardFileModel: { fileInfo: [], fileIDs: [] },
      modifyTourNo: false,
      selectedTravelCreateMode: '',
      dialogTravelChoiceVisible: false,
      isProdMode: process.env.NODE_ENV === 'production',
      selectedTaiwan: false,
      uploadPdf: {
        travelID: null,
        fileInfo: [],
      },
      pattern: {
        email:
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        mobile: /^09[0-9]{8}$/,
      },
      netWordcardDefaultOptions: [],
      demoAccounts: [],
      dialogDemoAccountVisible: false,
      currentLeaderRecordRow: null,
      currentTravelersRecordRow: null,
      dialogTravelersLoginRecordVisible: false,
      dialogLeaderLoginRecordVisible: false,
      onlyViewStatus: [2, 3, 4],
      travelOriginStatus: [],
      adminPermission: false,
      leaderSimpleForm: {},
      addLeaderTrigger: false,
      positionSubOptions: [],
      dialogPostitionSubVisible: false,
      currentNetworkCardFee: null,
      currentNetworkDesc: '',
      currentPlanningDescription: '',
      currentNetworkStatus: 1,
      referenceDate: '',
      referenceUser: null,
      dateInfoLoading: false,
      form: {},
      dialogVisible: false,
      dialogTopMargin: '1%',
      referenceData: [],
      positionDialogVisible: false,
      currentPositionData: null,
      isEditMode: false,
      dialoCurrencySubVisible: false,
      positionMsg: null,
      currencyMsg: null,
      selectedNetworkRow: {
        travelID: null,
        networkCardID: null,
        networkCard: false,
        networkCardCount: 0,
        networkOptions: [],
        memberCount: 0,
        postMode: 1,
        postFee: 0,
      },
      dialoNetworkSettingLoading: false,
      dialoNetworkSettingVisible: false,
      currencyOptions: [],
      currencySubOptions: [],
      carryItemCopyType: null,
      agencyTravels: [],
      selectedAgencyTravel: null,
      searchCarryItemsLoading: false,
      defaultCoupon: null,
      dialogLeaderViewVisible: false,
      dialoCarryItemsReferenceVisible: false,
      travelPropertyOption: [
        { label: '散客團', key: 1 },
        { label: '親友團', key: 2 },
        { label: '員工旅遊', key: 3 },
        { label: '獎勵旅遊', key: 4 },
        { label: '學生畢旅', key: 5 },
        { label: '其他團體', key: 6 },
      ],
      travelStatusOption: [
        { key: 'notSet', value: 0, label: '停用' },
        { key: 'preparing', value: 1, label: '準備中' },
        { key: 'processing', value: 2, label: '進行中' },
        { key: 'isOver', value: 3, label: '已結束' },
        { key: 'isOverAndDeleted', value: 4, label: '已結束(歸檔)' },
      ],
      travelAttributesOption: [
        { key: 'domesticTravel', value: 1, label: '國內旅遊' },
        { key: 'outboundTravel', value: 2, label: '出境旅遊' },
        { key: 'inboundTravelToTaiwan', value: 3, label: '來台旅遊' },
      ],
      exlImportErrorMsg: null,
      newCarryItem: { description: '' },
      carryItemsTab: 'required',
      carryItemsLoading: false,
      carryItems: {
        recommended: { items: [], remark: '' },
        required: { items: [], remark: '' },
      },
      travelersImportType: 1,
      seatType: null,
      isRefreshSeat: false,
      categories: [],
      commonFormsLoading: false,
      travelerLoading: false,
      couponLoading: false,
      couponShowToSurveyLoading: false,
      dialogCouponListVisible: false,
      couponFormData: defaultCouponForm,
      travelName: '',
      regionsSource: [],
      planningTab: 'thisDays',
      planDay: '',
      planningData: {
        thisTime: { data: [] },
        theDay: {
          // assemblingPlace: "",
          // hotelName: "",
          // departureTime: "",
          morningSights: '',
          afternoonAttractions: '',
          breakfast: '',
          lunch: '',
          dinner: '',
          eveningAttractions: '',
          // returnHotelTime: "",
          notesOnToday: '',
        },
      },
      fileObj: { id: 0, type: 'tourInfo', user: '' },
      dialogPlanningFormVisible: false,
      planningSettingLoading: false,
      originalTravelers: [],
      travelersList: [],
      pdfFiles: [],
      multipleSelection: [],
      dialogTravelersFormVisible: false,
      dialoSeatFormsVisible: false,
      dialoCarryItemsVisible: false,
      dialoCommonFormsVisible: false,
      travelersTableLoading: false,
      selectedTravelID: null,
      selectedLeaderUserID: null,
      leaderSettingLoading: false,
      leaderList: [],
      dialogLeaderFormVisible: false,
      agencyList: [],
      isAdd: true,
      formLabelWidth: '120px',
      formData: defaultForm,
      dialogFormVisible: false,
      dialogCouponFormVisible: false,
      listLoading: false,
      formLoading: false,
      travelerQuery: {
        qry: '',
      },
      leaderQuery: {
        qry: '',
        agencyCode: null,
      },
      groupCoupons: [],
      listQuery: {
        dates: null,
        travelProperty: null,
        memberCount: 0,
        countryArea: [],
        dateFilter: [],
        memberQry: '',
        qry: '',
        qrySecond: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-beginDate',
        agencyCode: null,
      },
      total: 0,
      list: [],
      agencyCode: '',
      agencyOptionDisabled: false,
      travelAttractionsMenu: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一週',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一個月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三個月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      // 行程開始日期
      pickerBeginDateLimitOptions: {
        disabledDate: time => {
          return time.getTime() < new Date().setHours(0, 0, 0, 0)
        },
      },
      pickerLimitOptions: {
        onPick: obj => {
          // console.log("obj", obj); // {maxDate: xxx, minDate: xxx(中国标准时间)}
          // this.selectedBeginDate = new Date(obj.minDate).getTime();
          // this.selectedEndDate = new Date(obj.maxDate).getTime();
        },
        disabledDate: time => {
          //旅遊團不卡控3天，改不限制 220206 by老闆
          const day1 = 1 * 24 * 3600 * 1000 //2天
          let minTime = new Date(this.formData.beginDate).getTime()
          return !(time.getTime() >= minTime - day1)
          // return !(time.getTime() >= minTime + day1);
        },
      },
      pickerFlightLimitOptions: {
        onPick: obj => {
          // console.log("obj", obj); // {maxDate: xxx, minDate: xxx(中国标准时间)}
          // this.selectedBeginDate = new Date(obj.minDate).getTime();
          // this.selectedEndDate = new Date(obj.maxDate).getTime();
        },
        disabledDate: time => {
          //旅遊團不卡控3天，改不限制 220206 by老闆
          const day1 = 1 * 24 * 3600 * 1000 //2天
          let minTime = new Date(this.formData.departureDate).getTime()
          return !(time.getTime() >= minTime - day1)
          // return !(time.getTime() >= minTime + day1);
        },
      },
      noticeSettingVisible: false,
      noticeSettingLoading: false,
      planSettingVisible: false,
      planSettingLoading: false,
      noticeContent: '',
      planContent: '',
      dialogDuplicateMultipleTravelVisible: false, // 複製多團彈窗
      dialogDuplicateMultipleTravelResultVisible: false,
      duplicateMultipleTravelResult: [],
      duplicateMultipleTravelLoading: false,
      duplicateTableFormData: {
        tableData: [],
      }, // 複製多團資料
      duplicateTravelFormData: {}, // 複製團資料
      travelFileObj: { id: 0, type: 'tourInfo', user: '' },
      travelFormData: { travelId: null, commonForms: [] },
      dialogTravelFormVisible: false,
    }
  },
  async created() {
    this.listLoading = true
    this.netWordcardDefaultOptions = [...Array(42).keys()].map(x => x + 10)
    this.adminPermission = checkPermission(['ITA-DEV', 'ITA-ADMIN'])
    await this.getCurrencyOptions()
    await this.getDefaultCoupon()
    await this.getTravelAttractionsCascaderMenu()
    await this.getTravelStatus()
    this.agencyCode = this.userInfo.agencyCode
    this.listQuery.agencyCode = this.agencyCode
    this.leaderQuery.agencyCode = this.agencyCode
    this.formData.agencyCode = this.agencyCode

    // 預設查詢前後14天資料  避免查詢時間過長
    // this.listQuery.dateFilter = [
    //   this.formattedDate(-14),
    //   this.formattedDate(+14)
    // ];

    console.log('開始時間', this.listQuery.dateFilter)

    if (checkPermission(['ITA-DEV', 'ITA-ADMIN'])) {
      this.agencyOptionDisabled = false
    } else {
      this.agencyOptionDisabled = true
    }
    //await this.getAgencyCouponsOption();

    this.getAgencyOptions()
    await this.getTourLeaders()
    await this.getList()
    //this.getCategories();
  },
  methods: {
    // 開啟報名連結編輯視窗
    openSignUpTravelDialog(row) {
      this.currentTravelId = row.id
      this.signUpNotice = row.signUpNotice || '' // 預填入已有資料
      this.signUpTravelDialogVisible = true
    },
    handleLinkClick(row) {
      this.dialogFormVisible = true // 控制對話框開啟
      this.formData = { ...row } // 將當列資料放入 formData
    },
    // 儲存報名連結
    async signUpTravel() {
      try {
        // API 呼叫載入資料
        let vm = this
        this.signUpTravelDialogVisible = false
        const resp = await createSignUpUrl({
          travelId: this.currentTravelId,
          signUpNotice: this.signUpNotice,
        })
        if (resp.success) {
          // vm.bulletinList = resp.data
          vm.$message({
            message: '儲存成功',
            type: 'success',
          })
        }
      } catch (error) {
        this.$message.error('儲存失敗')
      } finally {
        await this.refresh()
      }
    },
    closeDialogTravelBulletinBoardVisible() {
      this.dialogTravelBulletinBoardVisible = false
    },
    handleDialogOpen() {
      let vm = this
      vm.bulletinList = []
      // 載入公告列表
      this.loadBulletinList()
    },
    handleClose() {
      this.bulletinList.forEach(item => {
        if (item.fileInfo) {
          item.fileInfo = []
        }
      })
    },
    async loadBulletinList() {
      try {
        // API 呼叫載入資料
        let vm = this
        const resp = await getTravelBulletinBoard({ travelId: vm.selectedTravelID })
        if (resp.success) {
          vm.bulletinList = resp.data
          vm.dialogTravelBulletinBoardVisible = true
        }
      } catch (error) {
        this.$message.error('載入公告失敗')
      }
    },

    async handleBulletinSave(bulletin) {
      // await this.loadBulletinList()
      // console.log('保存公告:', bulletin)
      this.dialogTravelBulletinBoardVisible = false
    },

    async handleBulletinDelete(index) {},

    handleFileUpload(response) {
      console.log('檔案上傳成功:', response)
    },
    opLoginDateSetting(row) {
      const vm = this
      vm.selectedTravelID = row.id
      vm.dialogLoginDateVisible = true
    },
    async doGetLoginDate() {
      let vm = this
      let payload = {
        travelId: vm.selectedTravelID,
      }
      const resp = await getLoginDate(payload)
      if (resp.success) {
        vm.formData.loginDate = resp.data.loginDate
        vm.formData.loginDateEnable = resp.data.enable
        vm.dialogLoginDateVisible = true
      }
    },
    async doSaveLoginDate() {
      let vm = this
      let payload = {
        travelId: vm.selectedTravelID,
        loginDate: vm.formData.loginDate,
        enable: vm.formData.loginDateEnable,
      }
      const resp = await saveLoginDate(payload)
      if (resp.success) {
        vm.dialogLoginDateVisible = false
        vm.$message({
          message: '儲存成功',
          type: 'success',
        })
      }
    },
    async doGetSeminarMovieEvent() {
      let vm = this
      const travelId = vm.selectedTravelID
      const resp = await getSeminarMovieEvent({ travelId })
      if (resp.success) {
        if (resp.data.length > 0) {
          vm.travelSeminarMovieEventVisible = true
          vm.travelSeminarMovieEvent = resp.data
        } else {
          vm.$message({
            message: '查無資料',
            type: 'warning',
          })
        }
      }
    },
    async refreshItinerary() {
      let vm = this

      const payload = {
        travelID: vm.planningData.travelID,
      }
      vm.planningSettingLoading = true
      const resp = await refreshItinerary(payload)
      if (resp.success) {
        await vm.getItineraryPlanningSetting(vm.formData)
      }
      vm.planningSettingLoading = false
    },
    async chkTravelAttributesOption() {
      /*
      1=選擇國內旅遊，國家/區域的欄位自動選擇 台灣
      2=選擇出境旅遊，後台欄位和功能不變
      3=選擇來台旅遊，國家/區域的欄位不管選哪裡，旅遊天氣設定的選項都自動帶入台灣 (代表旅客來自的國家/區域)
      */
      let vm = this
      switch (vm.formData.travelAttributes) {
        case 1:
        case 3:
          vm.formData.countryAreaList = [['region_10']]
          await vm.getPositionAndCouurncy()
          break
        default:
          break
      }
    },
    async editTravelInfoAnalyticsForm() {
      this.dialogTravelFormVisible = true
    },
    async doTravelInfoAnalytics() {
      const vm = this
      if (!confirm(`確定要進行"AI智能分析旅程資訊"?`)) {
        return false
      }
      let refUpload = this.$refs['uploadRefTravel']

      let payload = await refUpload.combineFileAndPayload()
      if (!payload) {
        alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
        return false
      }

      payload.travelId = payload.id
      payload.agencyCode = this.$store.getters.userInfo.agencyCode
        ? this.$store.getters.userInfo.agencyCode
        : null
      // payload.tourGroupNo = "dev-ivan-test-0627-8";

      try {
        this.listLoading = true
        await this.$store.dispatch(
          'app/showDownloadLoadingText',
          'AI正在解析中，請不要離開此畫面，感謝您的耐心等候。'
        )
        await this.$store.dispatch('app/showDownloadLoading', this.listLoading)
        let res = await travelInfoAnalytics(payload)
        vm.listLoading = false
        vm.dialogTravelFormVisible = false
        vm.refresh()
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        if (!!error.data.data && !!error.data.data.code) {
          switch (error.data.data.code) {
            case 1001:
              let info = error.data.data.info
              const travelIds = Object.keys(info).map(Number)
              const tourNos = Object.values(info)
              if (!!tourNos) {
                let tourNo = tourNos[0]
                vm.listQuery.qry = tourNo
                vm.dialogTravelFormVisible = false
                vm.dialogTravelChoiceVisible = false
                await vm.getList()
                vm.editData(vm.list[0])
                alert(`${error.data.message}\n臨時團號為:${tourNo}`)
              }
              break
          }
        }
      } finally {
        vm.listLoading = false
        vm.formLoading = false
        refUpload.clearFiles()
        await this.$store.dispatch('app/showDownloadLoading', this.listLoading)
      }
    },
    checkHasMobile(userID) {
      if (!userID) return false
      let foundUser = this.originalTravelers.find(function (user) {
        return user.userID === userID
      })
      return !!(foundUser && foundUser.mobile)
    },
    handleView(url) {
      if (!!url) {
        window.open(url, '_blank')
      }
    },
    // 台北時區為準
    formattedDate(addDay) {
      const startDate = new Date()
      const timeZone = 'Asia/Taipei'
      const formattedDate2 = startDate.toLocaleString('en-US', {
        timeZone: timeZone,
      })
      const utcDate = new Date(formattedDate2 + ' UTC')
      const newFormattedDate = utcDate.toUTCString().replace('GMT', '')
      var oriDay = new Date(newFormattedDate)
      var date = new Date(newFormattedDate)
      date.setDate(oriDay.getDate() + addDay)
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return `${year}-${month}-${day}`
    },
    checkPermission,
    async travelersFormOnClose() {
      let refPdfUpload = this.$refs['uploadPdfRef']
      if (refPdfUpload) {
        refPdfUpload.clearFiles()
      }
      // TODO TEST
      this.isEditMode = false
      this.travelerQuery.qry = ''
      await this.getList()
    },
    notifyMovieTypeChange(val) {
      let notify = ''
      let style = ''
      this.formData.seminarMovieKind = val
      if (this.formData.seminarMovieKind == 1) {
        notify = '請上傳說明會影片，App將顯示此影片'
        style = 'warning'
      } else if (this.formData.seminarMovieKind == 2) {
        notify = '請輸入說明會影片網址，App將顯示此影片'
        style = 'warning'
      }
      this.$message({
        message: notify,
        type: style,
      })
    },
    partingLoginTime(data, type) {
      return data.filter(f => f.type == type)
    },
    // async test() {
    //   const request =
    //     "http://localhost:5294/api/Article/getTravelCascaderMenu";

    //   // fetch 會依照 request 去取得資料
    //   try {
    //     fetch(request)
    //       .then((response) => response.json()) // json()會解析回傳的Response物件
    //       .then((json) => console.log(json));
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    openUrl() {
      window.open(
        `${process.env.VUE_APP_S3_LINK}/template/exl/tour_travelers_import_temp_ver9.xlsx`,
        '_blank '
      )
    },
    handleDownloadPdf() {
      const path = this.pdfFiles && this.pdfFiles.length > 0 ? this.pdfFiles[0].url : ''
      console.log(path)
      if (!path) return
      window.open(path, '_blank ')
    },
    handleDeletePdf() {
      console.log(this.pdfFiles)
      this.pdfFiles = null
    },
    async saveDemoAccounts() {
      let vm = this

      if (
        confirm(
          `一個帳號只限同時間預覽一團，設定後將清除其他旅遊團預覽設定。\r\n確定設定預覽帳號嗎?`
        )
      ) {
        let payload = {
          agencyCode: vm.agencyCode || vm.formData.agencyCode,
          userIDs: vm.formData.demoAccounts,
          travelID: vm.formData.id,
        }
        vm.listLoading = true
        let resp = await saveDemoAccounts(payload)
        vm.listLoading = false
        if (resp.success) {
          this.dialogDemoAccountVisible = false
          this.$message({
            message: '預覽帳號設定完成。',
            type: 'success',
          })
        }
      }
    },
    async getAgencyMemberFilterCountiesList() {
      let resp = await getAgencyMemberFilterCountiesList({
        countries: this.formData.countryAreaList,
        agencyCode: this.agencyCode,
      })
      this.demoAccounts = resp.data.data
    },
    // async setDemoAccount() {
    //   let vm = this;
    //   vm.dialogDemoAccountVisible = true;
    // },

    async getLeaderLoginDetails() {
      let vm = this
      let resp = await getLeaderLoginRecord({
        travelID: vm.selectedTravelID,
        leaderUserID: vm.selectedLeaderUserID,
      })

      vm.currentLeaderRecordRow = resp.data[0]
      vm.dialogLeaderLoginRecordVisible = true
    },
    async getLoginDetails(row) {
      let vm = this
      vm.currentTravelersRecordRow = row
      vm.dialogTravelersLoginRecordVisible = true
    },
    checkStatusIsOverAndDeleted(status) {
      return status == 4
    },
    permissionCheck(status) {
      if (typeof status === 'undefined') {
        return false
      }
      let self = this

      let alwaysDisabled = self.travelOriginStatus.some(
        item => item.alwaysDisabled && item.id === status
      )

      if (alwaysDisabled) {
        return true
      }

      let disabled = self.onlyViewStatus.includes(status)
      if (disabled && !self.adminPermission) {
        return true
      }
      return false
    },
    async getTravelStatus() {
      let vm = this
      let result = await getTravelStatus()
      vm.travelOriginStatus = result.data
    },
    async getTravelLeaderUserID() {
      try {
        let resp = await getTravelLeaderUserID({
          travelID: this.selectedTravelID,
        })
        this.selectedLeaderUserID = resp.data.toString()
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
    async AddLeaderInfo() {
      if (!confirm(`確定要新增領隊資料?`)) {
        return
      }
      this.$refs['addLeaderForm'].validate(async valid => {
        if (valid) {
          this.leaderSimpleForm.agencyCode = this.agencyCode
          try {
            this.leaderSettingLoading = true
            let resp = await saveTourLeaderInfo(this.leaderSimpleForm)
            await this.getTourLeaders()
            this.addLeaderTrigger = false
          } catch (error) {
            console.log(error)
          } finally {
            this.leaderSettingLoading = false
            Message({
              message: '資料處理完成',
              type: 'success',
              duration: 5 * 1000,
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async showPosition() {
      await this.getPosition()
      this.dialogPostitionSubVisible = true
    },
    async getCurrentNetworkCardPostFee() {
      try {
        this.dialoNetworkSettingLoading = true
        let resp = await getCurrentNetworkCardPostFee({})
        if (this.selectedNetworkRow.postFee && this.selectedNetworkRow.postFee > 0) {
          this.currentNetworkCardFee = this.selectedNetworkRow.postFee
        } else {
          this.currentNetworkCardFee = resp.data.networkPostFee
        }
        this.dialoNetworkSettingLoading = false
      } catch (error) {}
    },
    selectedNetworkDesc() {
      let vm = this
      vm.currentNetworkDesc = vm.selectedNetworkRow.networkOptions.filter(f => {
        return f.key == vm.selectedNetworkRow.cardID
      })[0].desc
    },
    // FIXME: for test data
    async getTravelPositionRecordForTest(day, description) {
      const resp = {
        success: true,
        message: null,
        data: {
          user: {
            id: 1561,
            cUserName: '謝育澤',
            cAccount: '0967389048',
            cMobile: '0967389048',
            cBirthday: null,
            cPassword: null,
            cMail: '',
            cStatus: 1,
            cAgentUnit: null,
            cIsInitPwd: false,
            cPassportNo: null,
            cKind: 1,
            cUpdatorID: 185,
            cUpdateDT: '2023-12-13 09:34:17',
            cCreatorID: 1278,
            cCreateDT: '2023-12-11 10:34:51',
            nameBirthdayLoginType: null,
            isBirthdayVerified: null,
          },
          data: {
            total: 1,
            data: {
              applyType: 6,
              data: [
                {
                  applyType: 6,
                  date: '2023-12-17',
                  records: [
                    {
                      iDs: [2151349, 2151348, 2150967],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '16:40:35',
                      leaveTime: '17:05:40',
                      viewPointName: '難波八阪神社',
                      dwellTimeDays: 0,
                      dwellTimeHours: 0,
                      dwellTimeMinutes: 25,
                      dwellTimeSeconds: 5,
                      dwellTime: '25分5秒',
                      dwellTimeTotalMinutes: 1505,
                      lat: 34.66139,
                      lng: 135.4967,
                    },
                    {
                      iDs: [
                        2151744, 2151743, 2151741, 2151734, 2151726, 2151710, 2151709, 2151536,
                        2151516, 2151349, 2151348, 2150967, 2150935, 2150824, 2150770, 2150727,
                        2150671, 2150629,
                      ],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '16:33:30',
                      leaveTime: '18:22:49',
                      viewPointName: '御津三角公園',
                      dwellTimeDays: 0,
                      dwellTimeHours: 1,
                      dwellTimeMinutes: 49,
                      dwellTimeSeconds: 18,
                      dwellTime: '1小時49分18秒',
                      dwellTimeTotalMinutes: 6558,
                      lat: 34.67207,
                      lng: 135.4979,
                    },
                    {
                      iDs: [
                        2151710, 2151709, 2150967, 2150935, 2150824, 2150770, 2150727, 2150671,
                        2150629, 2150610, 2150584, 2150569,
                      ],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '16:30:32',
                      leaveTime: '18:10:07',
                      viewPointName: '大阪日本橋電器街',
                      dwellTimeDays: 0,
                      dwellTimeHours: 1,
                      dwellTimeMinutes: 39,
                      dwellTimeSeconds: 35,
                      dwellTime: '1小時39分35秒',
                      dwellTimeTotalMinutes: 5975,
                      lat: 34.66021,
                      lng: 135.5059,
                    },
                    {
                      iDs: [
                        2151743, 2151741, 2151734, 2151726, 2151710, 2151709, 2151536, 2151516,
                        2151349, 2151348, 2150967, 2150935, 2150824, 2150770, 2150727, 2150671,
                        2150629, 2150610, 2150584, 2150569, 2150545,
                      ],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '16:29:22',
                      leaveTime: '18:21:51',
                      viewPointName: '道頓堀',
                      dwellTimeDays: 0,
                      dwellTimeHours: 1,
                      dwellTimeMinutes: 52,
                      dwellTimeSeconds: 29,
                      dwellTime: '1小時52分29秒',
                      dwellTimeTotalMinutes: 6749,
                      lat: 34.66872,
                      lng: 135.5013,
                    },
                    {
                      iDs: [
                        2151743, 2151741, 2151734, 2151726, 2151710, 2151709, 2151536, 2151516,
                        2151349, 2151348, 2150967, 2150935, 2150824, 2150770, 2150727, 2150671,
                        2150629, 2150610, 2150584, 2150569, 2150545, 2150531,
                      ],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '16:28:22',
                      leaveTime: '18:21:51',
                      viewPointName: '心齋橋商店街',
                      dwellTimeDays: 0,
                      dwellTimeHours: 1,
                      dwellTimeMinutes: 53,
                      dwellTimeSeconds: 29,
                      dwellTime: '1小時53分29秒',
                      dwellTimeTotalMinutes: 6809,
                      lat: 34.67095,
                      lng: 135.5013,
                    },
                    {
                      iDs: [
                        2150497, 2150468, 2150258, 2150241, 2150236, 2150232, 2150212, 2150204,
                        2150197, 2150194, 2150180, 2150158, 2149951, 2149943, 2149930, 2149918,
                        2149906, 2149890, 2149881, 2149869,
                      ],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '15:06:09',
                      leaveTime: '16:25:22',
                      viewPointName: '大阪城 西之丸庭園',
                      dwellTimeDays: 0,
                      dwellTimeHours: 1,
                      dwellTimeMinutes: 19,
                      dwellTimeSeconds: 13,
                      dwellTime: '1小時19分13秒',
                      dwellTimeTotalMinutes: 4753,
                      lat: 34.68678,
                      lng: 135.5235,
                    },
                    {
                      iDs: [
                        2150508, 2150497, 2150468, 2150258, 2150241, 2150236, 2150232, 2150212,
                        2150204, 2150197, 2150194, 2150180, 2150158, 2149951, 2149943, 2149930,
                        2149918, 2149906, 2149890, 2149881, 2149869,
                      ],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '15:06:09',
                      leaveTime: '16:26:22',
                      viewPointName: '大阪城',
                      dwellTimeDays: 0,
                      dwellTimeHours: 1,
                      dwellTimeMinutes: 20,
                      dwellTimeSeconds: 13,
                      dwellTime: '1小時20分13秒',
                      dwellTimeTotalMinutes: 4813,
                      lat: 34.68521,
                      lng: 135.5257,
                    },
                    {
                      iDs: [2151745, 2142193, 2142186],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '08:17:11',
                      leaveTime: '18:23:54',
                      viewPointName: '靱公園',
                      dwellTimeDays: 0,
                      dwellTimeHours: 10,
                      dwellTimeMinutes: 6,
                      dwellTimeSeconds: 43,
                      dwellTime: '10小時6分43秒',
                      dwellTimeTotalMinutes: 36403,
                      lat: 34.6852,
                      lng: 135.4938,
                    },
                    {
                      iDs: [
                        2151743, 2151741, 2151734, 2151726, 2151710, 2151709, 2151536, 2151516,
                        2151349, 2151348, 2150967, 2150935, 2142186,
                      ],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '08:17:11',
                      leaveTime: '18:21:51',
                      viewPointName: '心齋橋',
                      dwellTimeDays: 0,
                      dwellTimeHours: 10,
                      dwellTimeMinutes: 4,
                      dwellTimeSeconds: 40,
                      dwellTime: '10小時4分40秒',
                      dwellTimeTotalMinutes: 36280,
                      lat: 34.67509293645317,
                      lng: 135.50040001109625,
                    },
                    {
                      iDs: [
                        2151749, 2142146, 2142140, 2142138, 2142136, 2142135, 2142128, 2142126,
                        2142107, 2142101, 2142099, 2142097, 2142090, 2142081, 2142077, 2142075,
                        2142070, 2142068, 2142063, 2142057, 2142049, 2142038, 2142033, 2142031,
                        2142028, 2142026, 2142021, 2142015, 2142012, 2142006, 2141996, 2141994,
                        2141992, 2141990, 2141988, 2141987, 2141985, 2141983, 2141981, 2141979,
                        2141976, 2141974, 2141972, 2141968, 2141965, 2141960, 2141955, 2141953,
                        2141951, 2141949, 2141946, 2141944, 2141943, 2141941, 2141939, 2141937,
                        2141935, 2141933, 2141931, 2141929, 2141925, 2141923, 2141920, 2141918,
                        2141916, 2141914, 2141913, 2141909, 2141908, 2141906, 2141904, 2141902,
                        2141900, 2141898, 2141896, 2141895, 2141894, 2141893, 2141891, 2141889,
                        2141888, 2141886, 2141884, 2141882, 2141880, 2141878, 2141876, 2141874,
                        2141872, 2141870, 2141868, 2141866, 2141864, 2141861, 2141859, 2141856,
                        2141854, 2141852, 2141849, 2141847, 2141845, 2141841, 2141839, 2141837,
                        2141835, 2141833, 2141831, 2141829, 2141827, 2141825, 2141823, 2141819,
                        2141816, 2141814, 2141811, 2141808, 2141805, 2141802, 2141800, 2141796,
                        2141794, 2141791, 2141788, 2141785, 2141782, 2141780, 2141776, 2141773,
                        2141771, 2141767, 2141762, 2141754, 2141752, 2141745, 2141742, 2141740,
                        2141738, 2141736, 2141734, 2141732, 2141730, 2141728, 2141726, 2141724,
                        2141722, 2141720, 2141718, 2141714, 2141710, 2141705, 2141703, 2141701,
                        2141699, 2141696, 2141695, 2141691, 2141690, 2141688, 2141686, 2141684,
                        2141679, 2141675, 2141671, 2141669, 2141662, 2141661, 2141659, 2141657,
                        2141655, 2141653, 2141651, 2141649, 2141648, 2141645, 2141643, 2141642,
                        2141639, 2141636, 2141635, 2141633, 2141631, 2141630, 2141629, 2141628,
                        2141627, 2141625, 2141624, 2141623, 2141622, 2141621, 2141620, 2141619,
                        2141618, 2141616, 2141613, 2141611, 2141603, 2141594, 2141590, 2141584,
                        2141582, 2141580, 2141573, 2141571, 2141570, 2141565, 2141557, 2141551,
                        2141546, 2141541, 2141540, 2141539, 2141538, 2141536, 2141526, 2141521,
                        2141518, 2141517, 2141512, 2141510, 2141508, 2141506, 2141504, 2141502,
                        2141500, 2141493, 2141484, 2141481, 2141477, 2141472, 2141467, 2141464,
                        2141463, 2141460, 2141458, 2141455, 2141450, 2141448, 2141446, 2141444,
                        2141439, 2141435, 2141433, 2141431, 2141427, 2141425, 2141423, 2141421,
                        2141419, 2141417, 2141415, 2141413, 2141410, 2141406, 2141401, 2141397,
                        2141389, 2141382, 2141374, 2141365, 2141359, 2141356, 2141354, 2141352,
                        2141349, 2141347, 2141345, 2141340, 2141338, 2141336, 2141334, 2141333,
                        2141329, 2141327, 2141325, 2141323, 2141321, 2141319, 2141318, 2141316,
                        2141314, 2141309, 2141305, 2141302, 2141298, 2141294, 2141292, 2141290,
                        2141288, 2141284, 2141282, 2141274, 2141266, 2141263, 2141257, 2141246,
                        2141240, 2141236, 2141230, 2141228, 2141226, 2141223, 2141221, 2141219,
                        2141215, 2141209, 2141206, 2141204, 2141202, 2141200, 2141196, 2141193,
                        2141186, 2141179, 2141177, 2141173, 2141171, 2141169, 2141165, 2141160,
                        2141153, 2141149, 2141141, 2141131, 2141124, 2141111, 2141100, 2141094,
                        2141085, 2141073, 2141063, 2141046, 2141024, 2141003, 2140986, 2140976,
                        2140964, 2140950, 2140939, 2140928, 2140915, 2140903, 2140899, 2140886,
                        2140875, 2140867, 2140859, 2140851, 2140836, 2140818, 2140807, 2140793,
                        2140786, 2140779, 2140777, 2140766, 2140755, 2140739, 2140720, 2140708,
                        2140695, 2140673, 2140653, 2140634, 2140623, 2140614, 2140600, 2140591,
                        2140588, 2140583, 2140560, 2140505, 2140443, 2140345, 2140295, 2140236,
                        2140223, 2140219, 2140205, 2140187, 2140176, 2140163, 2140138, 2140126,
                        2140116, 2140094, 2140066, 2140047, 2139987, 2139983, 2139982, 2139939,
                        2139929, 2139919, 2139905, 2139892, 2139886, 2139873, 2139857, 2139847,
                        2139839, 2139821, 2139806, 2139420,
                      ],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '00:01:33',
                      leaveTime: '18:28:49',
                      viewPointName: '天保山大摩天輪',
                      dwellTimeDays: 0,
                      dwellTimeHours: 18,
                      dwellTimeMinutes: 27,
                      dwellTimeSeconds: 16,
                      dwellTime: '18小時27分16秒',
                      dwellTimeTotalMinutes: 66436,
                      lat: 34.65627,
                      lng: 135.431,
                    },
                    {
                      iDs: [
                        2142160, 2142153, 2142146, 2142140, 2142138, 2142136, 2142135, 2142128,
                        2142126, 2142107, 2142101, 2142099, 2142097, 2142090, 2142081, 2142077,
                        2142075, 2142070, 2142068, 2142063, 2142057, 2142049, 2142038, 2142033,
                        2142031, 2142028, 2142026, 2142021, 2142015, 2142012, 2142006, 2141996,
                        2141994, 2141992, 2141990, 2141988, 2141987, 2141985, 2141983, 2141981,
                        2141979, 2141976, 2141974, 2141972, 2141968, 2141965, 2141960, 2141955,
                        2141953, 2141951, 2141949, 2141946, 2141944, 2141943, 2141941, 2141939,
                        2141937, 2141935, 2141933, 2141931, 2141929, 2141925, 2141923, 2141920,
                        2141918, 2141916, 2141914, 2141913, 2141909, 2141908, 2141906, 2141904,
                        2141902, 2141900, 2141898, 2141896, 2141895, 2141894, 2141893, 2141891,
                        2141889, 2141888, 2141886, 2141884, 2141882, 2141880, 2141878, 2141876,
                        2141874, 2141872, 2141870, 2141868, 2141866, 2141864, 2141861, 2141859,
                        2141856, 2141854, 2141852, 2141849, 2141847, 2141845, 2141841, 2141839,
                        2141837, 2141835, 2141833, 2141831, 2141829, 2141827, 2141825, 2141823,
                        2141819, 2141816, 2141814, 2141811, 2141808, 2141805, 2141802, 2141800,
                        2141796, 2141794, 2141791, 2141788, 2141785, 2141782, 2141780, 2141776,
                        2141773, 2141771, 2141767, 2141762, 2141754, 2141752, 2141745, 2141742,
                        2141740, 2141738, 2141736, 2141734, 2141732, 2141730, 2141728, 2141726,
                        2141724, 2141722, 2141720, 2141718, 2141714, 2141710, 2141705, 2141703,
                        2141701, 2141699, 2141696, 2141695, 2141691, 2141690, 2141688, 2141686,
                        2141684, 2141679, 2141675, 2141671, 2141669, 2141662, 2141661, 2141659,
                        2141657, 2141655, 2141653, 2141651, 2141649, 2141648, 2141645, 2141643,
                        2141642, 2141639, 2141636, 2141635, 2141633, 2141631, 2141630, 2141629,
                        2141628, 2141627, 2141625, 2141624, 2141623, 2141622, 2141621, 2141620,
                        2141619, 2141618, 2141616, 2141613, 2141611, 2141603, 2141594, 2141590,
                        2141584, 2141582, 2141580, 2141573, 2141571, 2141570, 2141565, 2141557,
                        2141551, 2141546, 2141541, 2141540, 2141539, 2141538, 2141536, 2141526,
                        2141521, 2141518, 2141517, 2141512, 2141510, 2141508, 2141506, 2141504,
                        2141502, 2141500, 2141493, 2141484, 2141481, 2141477, 2141472, 2141467,
                        2141464, 2141463, 2141460, 2141458, 2141455, 2141450, 2141448, 2141446,
                        2141444, 2141439, 2141435, 2141433, 2141431, 2141427, 2141425, 2141423,
                        2141421, 2141419, 2141417, 2141415, 2141413, 2141410, 2141406, 2141401,
                        2141397, 2141389, 2141382, 2141374, 2141365, 2141359, 2141356, 2141354,
                        2141352, 2141349, 2141347, 2141345, 2141340, 2141338, 2141336, 2141334,
                        2141333, 2141329, 2141327, 2141325, 2141323, 2141321, 2141319, 2141318,
                        2141316, 2141314, 2141309, 2141305, 2141302, 2141298, 2141294, 2141292,
                        2141290, 2141288, 2141284, 2141282, 2141274, 2141266, 2141263, 2141257,
                        2141246, 2141240, 2141236, 2141230, 2141228, 2141226, 2141223, 2141221,
                        2141219, 2141215, 2141209, 2141206, 2141204, 2141202, 2141200, 2141196,
                        2141193, 2141186, 2141179, 2141177, 2141173, 2141171, 2141169, 2141165,
                        2141160, 2141153, 2141149, 2141141, 2141131, 2141124, 2141111, 2141100,
                        2141094, 2141085, 2141073, 2141063, 2141046, 2141024, 2141003, 2140986,
                        2140976, 2140964, 2140950, 2140939, 2140928, 2140915, 2140903, 2140899,
                        2140886, 2140875, 2140867, 2140859, 2140851, 2140836, 2140818, 2140807,
                        2140793, 2140786, 2140779, 2140777, 2140766, 2140755, 2140739, 2140720,
                        2140708, 2140695, 2140673, 2140653, 2140634, 2140623, 2140614, 2140600,
                        2140591, 2140588, 2140583, 2140560, 2140505, 2140443, 2140345, 2140295,
                        2140236, 2140223, 2140219, 2140205, 2140187, 2140176, 2140163, 2140138,
                        2140126, 2140116, 2140094, 2140066, 2140047, 2139987, 2139983, 2139982,
                        2139939, 2139929, 2139919, 2139905, 2139892, 2139886, 2139873, 2139857,
                        2139847, 2139839, 2139821, 2139806, 2139420,
                      ],
                      applyType: 6,
                      date: '2023-12-17',
                      gatherAroundDate: '13:00',
                      startTime: '00:01:33',
                      leaveTime: '08:08:39',
                      viewPointName: '日本環球影城',
                      dwellTimeDays: 0,
                      dwellTimeHours: 8,
                      dwellTimeMinutes: 7,
                      dwellTimeSeconds: 6,
                      dwellTime: '8小時7分6秒',
                      dwellTimeTotalMinutes: 29226,
                      lat: 34.66575842478771,
                      lng: 135.43237750839083,
                    },
                  ],
                },
              ],
              buildUserID: 0,
              buildUserName: null,
              buildDate: null,
            },
          },
          date: '2023-12-17',
        },
      }
      this.referenceData = resp.data.data.data.data
      this.referenceUser = resp.data.user
      this.referenceDate = resp.data.date
      if (this.referenceData && this.referenceData.length > 0) {
        if (this.referenceData[0].records && this.referenceData[0].records.length > 0) {
          await this.viewReferenceData(this.referenceData[0])
        } else {
          this.$message({
            message: '該天數查無任何足跡紀錄。',
            type: 'error',
          })
        }
      } else {
        this.$message({
          message: '該天數查無任何足跡紀錄。',
          type: 'error',
        })
      }
    },
    async getTravelPositionRecord(day, description) {
      let vm = this
      vm.currentPlanningDescription = description
      vm.form = JSON.parse(JSON.stringify(defaultForm))
      try {
        vm.listLoading = true
        let resp = await getTravelPositionRecord({
          travelID: vm.formData.id,
          day,
        })
        vm.referenceData = resp.data.data.data.data

        if (vm.referenceData && vm.referenceData.length > 0) {
          if (this.referenceData[0].records && this.referenceData[0].records.length > 0) {
            await this.viewReferenceData(this.referenceData[0])
          } else {
            this.$message({
              message: '該天數查無任何足跡紀錄。',
              type: 'error',
            })
          }
        } else {
          this.$message({
            message: '該天數查無任何足跡紀錄。',
            type: 'error',
          })
        }

        vm.referenceUser = resp.data.user
        vm.referenceDate = resp.data.date
        // vm.dialogVisible = true;
      } catch (error) {
        console.log(error)
      } finally {
        vm.listLoading = false
      }
    },
    async googleMap(row) {
      let lat = row.lat
      let lng = row.lng
      let newWindow = window.open(`http://maps.google.com/?q=${lat},${lng}`)
      newWindow.opener = null
    },
    async viewReferenceData(row) {
      let vm = this
      vm.positionDialogVisible = true
      vm.currentPositionData = row
    },
    statusTranslateStyle(status) {
      let r = ''
      switch (status) {
        case 0:
          r = 'info'
          break
        case 1:
          r = 'success'
          break
        case 2:
          r = 'warning'
          break
        case 3:
        case 4:
          r = 'danger'
          break
        default:
          break
      }
      return r
    },
    async duplicateTravel(row) {
      let msg = `複製新的旅遊團耗時較久請耐心等待，視原始團檔案大小而定。\r\n\r\n複製項目：\r\n1、旅遊團基本資料(日期預設複製隔天出發)\r\n2、每日行程資料\r\n3、攜帶物品資料\r\n\r\n複製完畢後，請另行設定：\r\n1、正確旅遊日期區間\r\n2、領隊及旅客匯入、分組、安排座位\r\n3、上傳旅遊手冊、上傳說明會影片\r\n`
      alert(msg)

      if (confirm(`確定要複製【${row.travelName}】旅遊團資料?`)) {
        let tourNo = prompt(`請輸入團號`)
        if (!tourNo) {
          return
        }

        this.listLoading = true

        let payload = JSON.parse(JSON.stringify(row))
        payload.tourGroupNo = tourNo
        try {
          let resp = await duplicateTravel(payload)
          await this.getList()
        } catch (error) {
          console.log(error)
        } finally {
          this.listLoading = false
        }
      }
    },
    async addTravelers() {
      let vm = this
      if (vm.permissionCheck(vm.formData.status)) {
        alert(`目前旅遊團狀態不允許【新增/刪除】旅客資料。`)
        return
      }
      //選項設定為【旅客】
      vm.travelersImportType = 2
      let d = JSON.parse(JSON.stringify(defaultTravelers))
      vm.travelersList.push(d)
      vm.isEditMode = true
    },
    async deleteTravel(row) {
      if (!checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF'])) {
        alert(`未持有權限，無法刪除旅遊團資料。`)
        return
      }
      if (!confirm(`確定要刪除【${row.travelName}】旅遊團的所有相關資料?`)) {
        return
      }
      this.listLoading = true
      try {
        await deleteTravel({ travelID: row.id })
        Message({
          message: `資料處理完成。`,
          type: 'success',
        })
      } catch (error) {
        console.log(error)
      } finally {
        await this.refresh()
        this.listLoading = false
      }
    },
    async linkChkDefault(parm) {
      let vm = this
      let webLinksDesc = {
        official: '官網',
        fb: 'FB',
        line: 'Line',
        ig: 'IG',
        yt: 'Youtube',
      }

      let enabledParm = `${parm}Enable`
      if (
        vm.formData[enabledParm] &&
        !vm.formData[parm] &&
        confirm(`是否需要帶入旅行社設定的【${webLinksDesc[parm]}】連結?`)
      ) {
        let resp = await getAgencyAnSocialNetworkingLink({
          agencyCode: this.agencyCode,
          linkType: parm,
        })

        if (!resp.data) {
          alert(`旅行社尚未設定【${webLinksDesc[parm]}】連結`)
        }

        vm.formData[parm] = resp.data
      }
    },
    async getPositionAndCouurncy() {
      await this.getCurrency()
      await this.getPosition()
    },
    async getPosition() {
      let vm = this
      if (!vm.formData.countryAreaList || vm.formData.countryAreaList.length == 0) {
        return
      }

      let countryAreaList = JSON.parse(JSON.stringify(vm.formData.countryAreaList))

      //團體類別-來台旅遊 一律為台灣地點
      switch (vm.formData.travelAttributes) {
        case 3:
          countryAreaList = [['region_10']]
          break
        default:
          break
      }

      try {
        vm.formLoading = true
        let resp = await gePositionByCountries({
          countries: JSON.stringify(countryAreaList),
        })

        vm.positionSubOptions = resp.data
        //未選擇或有選過才加入
        vm.positionSubOptions.forEach(f => {
          if (vm.formData.position.length == 0 || vm.formData.position.includes(f.positionID)) {
            vm.formData.position.push(f.positionID)
          }
        })

        //array distinct 過濾重複
        if (vm.formData.position.length > 1) {
          vm.formData.position = vm.formData.position.filter((value, index, self) => {
            return self.indexOf(value) === index
          })
        }

        if (vm.positionSubOptions.length == 0) {
          vm.formData.position = []
        } else if (vm.positionSubOptions.length > 1) {
          vm.positionMsg = '此國家/區域對應多個地點，請根據旅遊目的地選擇地點'

          if (!vm.isAdd) {
            vm.dialogPostitionSubVisible = true
          }

          // vm.$message({
          //   message: "此國家/區域對應多個地點，請根據旅遊目的地選擇地點",
          //   type: "warning",
          // });
        }
      } catch (error) {
        console.log(error)
      } finally {
        vm.formLoading = false
      }
    },
    async getCurrency() {
      let vm = this

      if (!vm.formData.countryAreaList || vm.formData.countryAreaList.length == 0) {
        return
      }

      let countryAreaList = JSON.parse(JSON.stringify(vm.formData.countryAreaList))
      //團體類別-來台旅遊 一律為台灣貨幣
      switch (vm.formData.travelAttributes) {
        case 3:
          countryAreaList = [['region_10']]
          break
        default:
          break
      }

      //歐洲
      let regionEuro = 'region_7'

      let maps = []
      //array properties region/country to string (將陣列屬性 國家/城市 轉換為字串，較好判斷)
      countryAreaList.map(s => {
        maps.push(`${s[0]}${s[1]}`)
      })

      //array distinct 過濾重複
      maps = maps.filter((value, index, self) => {
        return self.indexOf(value) === index
      })

      //確認是否選擇歐洲
      let isEuro = maps.every(e => {
        return e.indexOf(regionEuro) != -1
      })

      //只有歐洲可以跨國家選城市
      if (!isEuro && maps.length > 1) {
        alert(`只限歐洲可跨國家選擇城市，系統直接剔除城市，請重新選擇。`)
        this.formData.countryAreaList = []
        countryAreaList = []
        return
      }

      let currencyPayload = countryAreaList[0]

      this.currencySubOptions = []

      let resp = await getCurrenciesByCountries({
        countries: JSON.stringify(currencyPayload),
      })
      if (resp.data.length == 0) {
        this.formData.currency = null
        this.$message({
          message: '此國家/區域沒有對應的貨幣，請自行選擇',
          type: 'error',
        })
        return
      } else if (resp.data.length > 1) {
        this.currencySubOptions = resp.data
        this.formData.currency = resp.data[0].key

        this.dialoCurrencySubVisible = true
        this.currencyMsg = '此國家/區域對應多種貨幣，請根據旅遊目的地選擇正確貨幣。'

        // this.$message({
        //   message: "此國家/區域對應多種貨幣，請根據旅遊目的地選擇正確貨幣。",
        //   type: "warning",
        // });
      } else if (resp.data.length == 1) {
        this.formData.currency = resp.data[0].key
        // this.$message({
        //   message: "貨幣已自動設定。",
        //   type: "success",
        // });
      }
    },
    async getCurrencyOptions() {
      let resp = await getCurrencyOptions()
      this.currencyOptions = resp.data
    },
    setCopyCarryItemType(type) {
      this.carryItemCopyType = type
      this.dialoCarryItemsReferenceVisible = true
    },
    async doCopyCarryItems() {
      if (!this.carryItemCopyType) {
        alert(`未知的物品類型。`)
        return
      }
      if (
        this.selectedAgencyTravel &&
        confirm(`確定要帶入他團攜帶物品?按下確定後會將原本的設定清除並取代。`)
      ) {
        let payload = {
          sourceTravelID: this.selectedAgencyTravel.id,
          targetTravelID: this.selectedTravelID,
          type: this.carryItemCopyType,
        }
        this.searchCarryItemsLoading = true
        let resp = await copyTravelCarryItems(payload)
        this.dialoCarryItemsReferenceVisible = false
        this.dialoCarryItemsVisible = false
        this.searchCarryItemsLoading = false
        Message({
          message: `【${type == 1 ? '建議攜帶物品' : '必要攜帶物品'}】設定處理完成。`,
          type: 'success',
          duration: 3 * 1000,
        })
      } else {
        alert(`請選擇旅遊團`)
      }
    },
    async getAgencyTravelsAndOtherInformation() {
      let query = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 0,
        filterType: 2,
        sort: '-id',
      }
      this.searchCarryItemsLoading = true
      let resp = await getAgencyTravelsAndOtherInformation(query)
      this.agencyTravels = resp.data.data
      this.searchCarryItemsLoading = false
    },
    defaultListyQuerySetting() {
      this.listQuery.travelProperty = null
      this.listQuery.memberCount = 50
      this.listQuery.countryArea = []
      this.listQuery.dateFilter = []
      this.listQuery.qry = ''
      this.listQuery.qrySecond = ''
      this.listQuery.date = ''
      this.listQuery.status = null
      this.listQuery.page = 1
      this.listQuery.limit = 20
      this.listQuery.sort = '-beginDate'
    },
    async refresh() {
      this.defaultListyQuerySetting()
      await this.getList()
    },
    async getDefaultCoupon() {
      let vm = this
      let agencyCode = this.$store.getters.userInfo.agencyCode
        ? this.$store.getters.userInfo.agencyCode
        : null
      if (!agencyCode) {
        // alert(`未取得旅行社代碼，無法取得預設票券。`);
        vm.defaultCoupon = null

        return false
      }
      let resp = await getDefaultCoupon({ agencyCode })
      vm.defaultCoupon = resp.data
    },
    // async getAgencyCouponsOption() {
    //   let agencyCode = null;
    //   if (!checkPermission(["ITA-DEV", "ITA-ADMIN"])) {
    //     agencyCode = this.agencyCode;
    //   }

    //   let resp = await getAgencyCouponsOption({ agencyCode });
    //   this.groupCoupons = resp.data;
    // },

    async saveTravelNetworkSetting() {
      let payload = {
        travelID: this.selectedNetworkRow.travelID,
        cardID: this.selectedNetworkRow.networkCard ? this.selectedNetworkRow.cardID : null,
        cardCount: this.selectedNetworkRow.cardCount,
        postMode: this.selectedNetworkRow.postMode,
        postFee: this.currentNetworkCardFee,
      }
      if (
        this.selectedNetworkRow.networkCard &&
        (!this.selectedNetworkRow.cardID || !this.selectedNetworkRow.cardCount)
      ) {
        alert(`請選擇網卡數量`)
        return
      }
      if (!this.selectedNetworkRow.postMode) {
        alert(`請選擇網卡寄送方式`)
        return
      }

      if (!confirm(`確定要儲存網卡購買?`)) {
        return
      }

      this.dialoNetworkSettingLoading = true
      try {
        let resp = await saveTravelNetworkSetting(payload)
        this.getList()

        Message({
          message: `網卡購買處理完成`,
          type: 'success',
          duration: 3 * 1000,
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.dialoNetworkSettingVisible = false
        this.dialoNetworkSettingLoading = false
      }
    },
    async getTravelNetworkSetting(id) {
      let resp = await getTravelNetworkSetting({ travelID: id })
      let data = resp.data

      if (data) {
        this.selectedNetworkRow.networkCard = data != null
        this.selectedNetworkRow.cardID = data.cardID
        this.selectedNetworkRow.cardCount = data.cardCount
        this.selectedNetworkRow.postMode = data.postMode
        this.selectedNetworkRow.postFee = data.postFee
      } else {
        this.selectedNetworkRow.cardID = null
      }
    },
    async setTravelNetworkCard(row) {
      if (!row.id) {
        return
      }

      this.currentNetworkStatus = row.networkCardStatus

      let networkCardResult = await getNetworkCardOptions({
        countryArea: row.countryAreaList,
      })

      this.selectedNetworkRow = {
        travelID: row.id,
        networkCard: row.networkCard != null,
        cardID: row.networkCard ? row.networkCard.cardID : null,
        cardCount: row.networkCard ? row.networkCard.cardCount : null,
        networkOptions: networkCardResult.data,
        memberCount: row.memberCount,
        postMode: row.networkCard ? row.networkCard.postMode : 1,
        postFee: row.networkCard ? row.networkCard.postFee : null,
      }
      this.travelName = row.travelName
      await this.getTravelNetworkSetting(row.id)
      this.dialoNetworkSettingVisible = true
    },
    saveTravelNetwork() {
      let vm = this
    },
    checkDefault(v, type) {
      let vm = this
      vm.formData[type] = v
      if (!vm.formData[type]) {
        vm.formData[type] = v
      }
    },
    async getTravelAttractionsCascaderMenu() {
      let resp = await getTravelAttractionsCascaderMenu()
      this.travelAttractionsMenu = resp.data
    },
    isRepeat(type, arr) {
      var hash = []
      for (var i in arr) {
        let elem = arr[i]
        if (hash.includes(elem.description)) {
          alert(`${type} 重複項目：${elem.description}`)
          return true
        }
        hash.push(elem.description)
      }
      return false
    },
    async settingCarryItems() {
      let vm = this
      if (confirm(`確定儲存攜帶物品?`)) {
        if (vm.isRepeat('建議攜帶物品', vm.carryItems.recommended.items)) {
          return
        }

        if (vm.isRepeat('必要攜帶物品', vm.carryItems.required.items)) {
          return
        }
        vm.carryItemsLoading = true
        try {
          let resp = await settingCarryItems(vm.carryItems)
          Message({
            message: `資料處理完成。`,
            type: 'success',
            duration: 5 * 1000,
          })
          vm.dialoCarryItemsVisible = false
          vm.carryItemsLoading = false
        } catch (error) {
          vm.carryItemsLoading = false
        }
      }
    },
    deleteCarryItem(type, index) {
      let vm = this
      let op
      switch (type) {
        case 'recommended':
          op = vm.carryItems.recommended.items[index]
          if (op.description) {
            if (confirm(`確定刪除攜帶物品?`)) {
              vm.carryItems.recommended.items.splice(index, 1)
            }
          } else {
            vm.carryItems.recommended.items.splice(index, 1)
          }
          break
        case 'required':
          op = vm.carryItems.required.items[index]
          if (op.description) {
            if (confirm(`確定刪除攜帶物品?`)) {
              vm.carryItems.required.items.splice(index, 1)
            }
          } else {
            vm.carryItems.required.items.splice(index, 1)
          }
          break
        default:
          break
      }
    },
    addCarryItem(type) {
      let vm = this
      // if (!vm.newCarryItem.description.trim()) {
      //   alert(`請輸入物品描述。`);
      //   return false;
      // }
      let newItems = []

      if (vm.newCarryItem.description) {
        let spString = vm.newCarryItem.description.split('|')
        for (let index = 0; index < spString.length; index++) {
          const element = spString[index]
          let newItem = {
            id: null,
            description: element,
          }
          newItems.push(newItem)
        }
      } else {
        newItems.push({
          id: null,
          description: '',
        })
      }

      switch (type) {
        case 'recommended':
          for (let index = 0; index < newItems.length; index++) {
            const element = newItems[index]
            vm.carryItems.recommended.items.push(element)
          }
          break
        case 'required':
          for (let index = 0; index < newItems.length; index++) {
            const element = newItems[index]
            vm.carryItems.required.items.push(element)
          }
          break
        default:
          break
      }
    },
    async getCarryItemsSetting(row) {
      let vm = this
      vm.formData = JSON.parse(JSON.stringify(row))
      vm.carryItemsLoading = true
      vm.selectedTravelID = row.id
      let resp = await getCarryItemsSetting({ travelID: vm.selectedTravelID })
      vm.carryItems = resp.data
      vm.travelName = row.travelName
      vm.dialoCarryItemsVisible = true
      vm.carryItemsLoading = false
    },
    seatCallback(travelID, seatType) {
      let vm = this
      vm.dialoSeatFormsVisible = false
      let find = vm.list.filter(f => {
        return f.id == travelID
      })[0]
      if (find) {
        find.seatType = seatType
        vm.editSeatForms(find)
      }
    },
    fatherDialogSeatFormVisible(action) {
      let vm = this
      vm.dialoSeatFormsVisible = action
    },
    // async getCategories() {
    //   let vm = this;
    //   getCouponLoopCategoryOptions().then((resp) => {
    //     vm.categories = resp.data;
    //   });
    // },
    // async doUploadCommonForms() {
    //   if (!confirm(`確認儲存常用表單?`)) {
    //     return false;
    //   }
    //   let vm = this;
    //   let refUpload = this.$refs["uploadCommonFormsRef"];
    //   let payload = await refUpload.combineFileAndPayload();
    //   if (!payload) {
    //     alert("檔案繫結表單發生未知錯誤，無法儲存資料。");
    //     return false;
    //   }
    //   try {
    //     if (refUpload.fileList && refUpload.fileList.length > 0) {
    //       vm.commonFormsLoading = true;

    //       let res = await saveGroupTourCommonForms(payload);
    //       vm.commonFormsLoading = false;
    //       vm.getTravelers(vm.selectedTravelID);
    //       // refUpload.clearFiles();
    //       await vm.getList();
    //       vm.dialoCommonFormsVisible = false;
    //       Message({
    //         message: `完成上傳。`,
    //         type: "success",
    //         duration: 5 * 1000,
    //       });
    //     } else {
    //       Message({
    //         message: `請選擇檔案`,
    //         type: "error",
    //         duration: 5 * 1000,
    //       });
    //     }
    //   } catch (error) {
    //     vm.commonFormsLoading = false;
    //   }
    // },
    async doImportExcel() {
      if (!confirm(`確認匯入旅客資料?`)) {
        return false
      }

      let vm = this
      let f = vm.formData

      vm.exlImportErrorMsg = null
      let refUpload = this.$refs['excelImportRef']
      let payload = await refUpload.combineFileAndPayload()
      if (!payload) {
        alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
        return false
      }

      try {
        if (refUpload.fileList && refUpload.fileList.length > 0) {
          vm.travelerLoading = true

          payload.importType = vm.travelersImportType
          try {
            let res = await parseTravelersExcel(payload)
            vm.travelersList = res.data.travelers
          } catch (error) {
            console.log(error)
            vm.travelerLoading = false
            return
          }
          vm.travelerLoading = false

          // vm.getTravelers(vm.selectedTravelID);
          refUpload.clearFiles()
          // await vm.getTravelLeaderUserID();
          // await vm.getTourLeaders();
          // await vm.refresh();
          Message({
            message: `完成匯入。`,
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          Message({
            message: `請選擇檔案`,
            type: 'error',
            duration: 5 * 1000,
          })
        }
      } catch (error) {
        let msg = error.response.data.message ? error.response.data.message : ''
        vm.exlImportErrorMsg = msg
        vm.travelerLoading = false
      }
    },
    //async setCouponShowToSurvey() {
    // let vm = this;
    // console.log(vm.formData.coupon.disabled);
    // let payload = {
    //   travelID: vm.selectedTravelID,
    //   isSelected: row.showToSurvey,
    //   couponID: row.id,
    // };
    // vm.couponShowToSurveyLoading = true;
    // let res = await switchTravelCouponShowToSurvey(payload);
    // await vm.getTravelCoupons();
    // vm.couponShowToSurveyLoading = false;
    //},
    // selectedCouponFromList() {
    //   let vm = this;
    //   vm.dialogCouponListVisible = true;
    // },
    // addCoupon() {
    //   this.dialogCouponFormVisible = true;
    //   this.couponFormData = defaultCouponForm;
    // },
    // editCoupon(row) {
    //   let vm = this;
    //   vm.couponFormData = null;
    //   setTimeout(() => {
    //     vm.couponFormData = row;
    //     vm.dialogCouponFormVisible = true;
    //   }, 200);
    // },
    // async deleteCoupon(row) {
    //   if (!confirm(`確定要刪除此筆票券?`)) {
    //     return;
    //   }
    //   let vm = this;
    //   let payload = {
    //     travelID: vm.selectedTravelID,
    //     couponID: row.id,
    //   };
    //   vm.couponLoading = true;
    //   let res = await deleteTravelCoupon(payload);
    //   await vm.getTravelCoupons();
    //   vm.couponLoading = false;
    // },
    // async getTravelCoupons() {
    //   let vm = this;
    //   let res = await getTravelCoupons({ travelID: this.selectedTravelID });
    //   if (!vm.couponLoading) {
    //     vm.couponLoading = true;
    //   }
    //   vm.formData.coupons = res.data;
    //   if (vm.couponLoading) {
    //     vm.couponLoading = false;
    //   }
    // },
    eidtPassPoint(row, day) {
      const vm = this
      row.passPointDialogVisible = true
    },
    async planningSettingSave() {
      if (!confirm(`確定儲存【${this.travelName}】的行程設定?`)) {
        return
      }
      const vm = this

      vm.planningSettingLoading = true
      const thisTimeData = []
      let isValid = true
      vm.planningData.thisTime.data.forEach((element, index) => {
        element.day = index + 1
        const { id, region, country, city, day, description, food, hotelName, lat, lng } = element
        if (!country && checkPermission(['ITA-DEV'])) {
          Message({
            message: `行程第${element.day}天，請選擇國家。`,
            type: 'error',
            duration: 5 * 1000,
          })
          isValid = false
          return false
        }
        if (!lat || parseFloat(lat == 0) || !lng || parseFloat(lng == 0)) {
          if (checkPermission(['ITA-DEV'])) {
            Message({
              message: `行程第${element.day}天，經緯度錯誤，請輸入正確經緯度。`,
              type: 'error',
              duration: 5 * 1000,
            })
            isValid = false
            return false
          }
        }
        const p = {
          id,
          region,
          country,
          city,
          day,
          description,
          food,
          hotelName,
          lat,
          lng,
        }
        thisTimeData.push(p)
      })
      thisTimeData[thisTimeData.length - 1].hotelName =
        thisTimeData[thisTimeData.length - 1].hotelName || '溫暖的家'

      if (!isValid && checkPermission(['ITA-DEV'])) {
        vm.planningSettingLoading = false
        return
      }

      vm.planningData.fileInfo = []
      let refUpload = vm.$refs['uploadHandbookRef']
      let payload = await refUpload.combineFileAndPayload()
      if (!payload) {
        alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
        vm.planningSettingLoading = false

        return false
      }
      if (thisTimeData) {
        let emptis = thisTimeData.filter(f => {
          return !f.description
        })
        // if (emptis.length > 0 && vm.planningTab == 'thisDays') {
        //   alert('行程說明未輸入')
        //   vm.planningSettingLoading = false
        //   return false
        // }
        let emptisHotel = thisTimeData.filter(f => {
          return !f.hotelName
        })
        // if (emptisHotel.length > 0 && vm.planningTab == "thisDays") {
        //   alert("住宿旅館未輸入");
        //   vm.planningSettingLoading = false;
        //   return false;
        // }
      }
      payload = JSON.parse(JSON.stringify(vm.planningData))
      payload.thisTime.data = thisTimeData
      payload.travelID = vm.selectedTravelID

      await saveItineraryPlanningSetting(payload).then(response => {
        vm.getList()
        vm.dialogPlanningFormVisible = false
        vm.planningSettingLoading = false
        Message({
          message: '行程設定完成',
          type: 'success',
          duration: 5 * 1000,
        })
      })
    },
    async getCountryRegions() {
      const vm = this
      vm.regionsSource = []

      await getCountryRegions({}).then(response => {
        vm.regionsSource = response.data
      })
    },
    async selectedRegion(data) {
      const vm = this
      data.country = null
      data.city = null
      data.countries = []
      data.cities = []

      data.countriesLoading = true
      await getCountriesByRegion({ region: data.region }).then(response => {
        data.countriesLoading = false
        data.countries = response.data
      })
    },
    async selectedCountry(data) {
      const vm = this
      data.city = null
      data.cities = []

      // if (!data.country.code) {
      //   data.cities = []
      //   return
      // }
      data.cities = []
      data.citiesLoading = true
      data.lat = data.country.lat
      data.lng = data.country.lng
      await getCitiesByCountryCode({ countryCode: data.country.code }).then(response => {
        data.citiesLoading = false
        data.cities = response.data
      })
    },
    async selectedCity(data) {
      const vm = this
      data.lat = data.city.lat
      data.lng = data.city.lng
    },
    deletePlanning: function (event) {
      const vm = this
      vm.planningData.thisTime.data.splice(vm.planningData.thisTime.data.indexOf(event), 1)
    },
    async addNewPlanning() {
      const vm = this
      let emptyObj = {}

      const dataLen = vm.planningData.thisTime.data.length
      if (dataLen > 0) {
        const copyObj = vm.planningData.thisTime.data[dataLen - 1]
        emptyObj = JSON.parse(JSON.stringify(copyObj))
        emptyObj.id = null
        emptyObj.description = null
        emptyObj.hotelName = null
      } else {
        emptyObj = {
          regions: JSON.parse(JSON.stringify(vm.regionsSource)),
          countries: [],
          cities: [],
          lat: '',
          lng: '',
          citiesLoading: false,
          countriesLoading: false,
          passPointDialogVisible: false,
          description: '',
          hotelName: '',
        }
      }

      vm.planningData.thisTime.data.push(emptyObj)
    },
    async getItineraryPlanningSetting(row) {
      try {
        this.clearPlanningFiles()
        this.formData = JSON.parse(JSON.stringify(row))
        this.planningSettingLoading = true
        this.selectedTravelID = row.id
        this.travelName = row.travelName
        this.dialogPlanningFormVisible = true

        await this.getCountryRegions()

        const response = await getItineraryPlanningSetting({ travelID: this.selectedTravelID })

        this.planningSettingLoading = false

        if (response.data.thisTime.data && response.data.thisTime.data.length > 0) {
          const lastItem = response.data.thisTime.data[response.data.thisTime.data.length - 1]
          if (lastItem.hotelName === '') {
            const HOME_NAME = '溫暖的家'
            lastItem.hotelName = HOME_NAME
          }
        }

        this.planningData = response.data
      } catch (error) {
        console.error('Error fetching itinerary planning setting:', error)
        this.planningSettingLoading = false
        // 處理錯誤，例如顯示錯誤消息給用戶
      }
    },
    async deleteTravelers(userID, userName, index) {
      const vm = this
      if (vm.permissionCheck(vm.formData.status)) {
        alert(`目前旅遊團狀態不允許【新增/刪除】旅客資料。`)
        return
      }
      var name = userName == null ? '' : '【' + userName + '】'
      if (confirm(`確定要取消該旅客${name}資料`)) {
        if (!userID) {
          vm.travelersList.splice(index, 1)
        } else {
          vm.travelersTableLoading = true
          const travelID = vm.selectedTravelID

          await deleteTravelers({ travelID, userID }).then(async response => {
            vm.travelersTableLoading = false
            await vm.getTravelers()
          })
        }
      }
    },
    // async removeTravelers(userID, userName) {
    //   if (confirm(`確定要刪除旅客【${userName}】`)) {
    //     const vm = this;
    //     vm.travelersTableLoading = true;
    //     await removeTravelers({ userID }).then(async (response) => {
    //       vm.travelersTableLoading = false;
    //       await vm.getTravelers();
    //     });
    //   }
    // },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    async setTravelers() {
      let refUpload = this.$refs['excelImportRef']

      if (refUpload && refUpload.fileList && refUpload.fileList.length > 0) {
        Message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: `系統偵測已有選擇Excel檔案，但尚未匯入。請問是否需要匯入檔案?需要請按下【匯入】，否則請將檔案移除，謝謝`,
          type: 'error',
          duration: 10 * 1000,
        })
        return
      }

      try {
        this.travelersList.forEach(item => {
          if (item.birthDay) {
            // 定義允許的日期格式的正規表達式
            const dateFormatRegex = /^(?:\d{4}\/\d{2}\/\d{2}|\d{4}-\d{2}-\d{2})$/
            // 驗證日期格式
            if (!dateFormatRegex.test(item.birthDay)) {
              this.$message.error('生日日期格式不正確')
              throw BreakException
            }

            // 使用 dayjs 解析日期
            const isValidBirthday =
              dayjs(item.birthDay, 'YYYY-MM-DD', true).isValid() ||
              dayjs(item.birthDay, 'YYYY/MM/DD', true).isValid()
            console.log('isValidBirthday')
            console.log(isValidBirthday)

            // 驗證日期是否有效
            if (!isValidBirthday) {
              this.$message.error('生日日期不是有效日期')
              throw BreakException
            }
          }
          if (!item.name) {
            this.$message.error('旅客姓名為必填項目')
            throw BreakException
          }
          if (!item.isMain && !item.travelersGroup) {
            this.$message.error('次要旅客，分組為必填項目')
            throw BreakException
          }
          // 旅客電話改為非必填
          // if (!item.mobile) {
          //   this.$message.error("旅客電話為必填項目");
          //   throw BreakException;
          // }

          if (item.travelersGroup) {
            const travelerGroup = this.travelersList.filter(
              traveler => traveler.travelersGroup === item.travelersGroup
            )
            const travelerGroupMain = travelerGroup.map(traveler => traveler.isMain)
            const hasMain = travelerGroupMain.includes(true)
            if (!hasMain) {
              this.$message.error('分組內必須有一名主要旅客')
              throw BreakException
            }
          }

          if (item.isMain && !item.birthDay) {
            this.$message.error('主要旅客，生日為必填項目')
            throw BreakException
          }

          if (item.mail && !verifyEmail(item.mail)) {
            this.$message.error('Email格式錯誤')
            throw BreakException
          }
        })
      } catch (e) {
        return false
      }

      // if (confirm(`確定要儲存旅客【${data.name}】資料?`)) {
      if (confirm(`確定要儲存旅客資料?`)) {
        const vm = this
        const travelID = vm.selectedTravelID
        const travelers = vm.travelersList //[data];
        // if (vm.multipleSelection.length == 0) {
        //   return false;
        // }
        // vm.multipleSelection.forEach((f) => {
        //   travelers.push(f);
        // });
        let refPdfUpload = this.$refs['uploadPdfRef']
        let payload = await refPdfUpload.combineFileAndPayload()
        if (!payload) {
          alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
          return false
        }
        const uploadPdfParams = {
          travelID: travelID,
          fileInfo: payload.fileInfo,
        }
        vm.travelersTableLoading = true
        try {
          let pdfUploadRes = await uploadTravelers(uploadPdfParams)
          refPdfUpload.clearFiles()
          console.log(this.pdfFiles)
          const formatFile = !!this.pdfFiles
            ? {
                file: this.pdfFiles,
                type: 36,
              }
            : null
          let response = await setTravelers({
            travelID,
            travelers,
            file: formatFile,
          })
          if (response.success) {
            this.travelersTableLoading = false
            Message({
              message: '資料處理完成',
              type: 'success',
              duration: 5 * 1000,
            })
            this.dialogTravelersFormVisible = false
          }
          // await vm.getTravelers();
        } catch (error) {
          console.log(error)
          await this.getTravelers()
          this.isEditMode = false
        } finally {
          this.travelersTableLoading = false
        }
      }
    },
    async getTravelers() {
      this.travelersTableLoading = true
      this.travelerQuery.travelID = this.selectedTravelID
      let response = await getTravelers(this.travelerQuery)
      this.originalTravelers = JSON.parse(JSON.stringify(response.data.travelers))
      this.travelersList = response.data.travelers
      this.pdfFiles = response.data.file ? response.data.file.files : []
      this.travelersTableLoading = false
    },
    editTravelers(row) {
      const vm = this
      vm.formData = JSON.parse(JSON.stringify(row))
      vm.selectedTravelID = row.id

      if (row.leaderUserID) {
        vm.selectedLeaderUserID = row.leaderUserID.toString()
      } else {
        vm.selectedLeaderUserID = null
      }
      vm.travelName = row.travelName
      vm.getTravelers(row.id)
      vm.dialogTravelersFormVisible = true
    },
    editSeatForms(row) {
      const vm = this
      vm.formData = JSON.parse(JSON.stringify(row))
      vm.seatType = row.seatType
      vm.selectedTravelID = row.id
      vm.travelName = row.travelName
      vm.dialoSeatFormsVisible = true
      vm.isRefreshSeat = false
      setTimeout(() => {
        vm.isRefreshSeat = true
      }, 200)
    },
    // editCommonForms(row) {
    //   const vm = this;
    //   vm.formData = row;
    //   vm.selectedTravelID = row.id;
    //   // vm.getTravelers(row.id);
    //   vm.dialoCommonFormsVisible = true;
    // },
    leaderSetting(row) {
      const vm = this
      vm.formData = row
      vm.selectedTravelID = row.id
      if (row.leaderUserID) {
        vm.selectedLeaderUserID = row.leaderUserID.toString()
      } else {
        vm.selectedLeaderUserID = null
      }
      vm.travelName = row.travelName
      vm.dialogLeaderFormVisible = true
    },
    async getTourLeaders() {
      getTourLeaders(this.leaderQuery).then(response => {
        this.leaderList = response.data
      })
    },
    leaderViewdialog(toDo) {
      this.dialogLeaderViewVisible = toDo
    },
    viewTourLeader() {
      this.dialogLeaderViewVisible = true
    },
    leaderViewOpenedHandle() {
      let sID = this.selectedLeaderUserID
      this.selectedLeaderUserID = null
      setTimeout(() => {
        this.selectedLeaderUserID = sID
      }, 300)
    },
    async setTourLeader() {
      let vm = this
      if (!this.selectedLeaderUserID) {
        alert('請選擇領隊')
        return false
      }
      this.leaderSettingLoading = true
      try {
        await setTourLeader({
          travelID: this.selectedTravelID,
          leaderUserID: this.selectedLeaderUserID,
        }).then(async response => {
          this.leaderSettingLoading = false
          Message({
            message: '領隊設定完成',
            type: 'success',
            duration: 5 * 1000,
          })
          this.dialogLeaderFormVisible = false
        })
      } catch (error) {
        this.leaderSettingLoading = false
      } finally {
        await this.getList()
        await this.getTourLeaders()
        this.listLoading = false
        this.dialogLeaderFormVisible = false
      }
    },
    async getAgencyOptions() {
      await getAgencyOptions().then(response => {
        this.agencyList = response.data
      })
    },
    async addData() {
      const vm = this
      vm.isAdd = true
      vm.selectedTravelID = null
      vm.formData = JSON.parse(JSON.stringify(defaultForm))
      vm.formData.fileInfo = []

      var socialNetworkingLinks = await getAgencySocialNetworkingLink({
        agencyCode: this.agencyCode,
      })

      Object.keys(socialNetworkingLinks.data).forEach(keys => {
        let link = socialNetworkingLinks.data[keys]
        vm.formData[keys] = link

        vm.formData[`${keys}Enable`] = link ? true : false
      })

      if (vm.defaultCoupon) {
        vm.formData.coupon = vm.defaultCoupon
      }

      if (vm.listQuery.qry) {
        vm.formData.tourGroupNo = vm.listQuery.qry
      }

      if (vm.listQuery.qrySecond) {
        vm.formData.travelName = vm.listQuery.qrySecond
      }

      vm.formData.countryAreaList = vm.listQuery.countryArea
      if (vm.formData.countryAreaList && vm.formData.countryAreaList.length > 0) {
        await vm.getPositionAndCouurncy()
      }

      vm.formData.memberCount = vm.listQuery.memberCount
      vm.formData.travelProperty = vm.listQuery.travelProperty
      // // 不要將條件日期寫入
      // if (vm.listQuery.dateFilter && vm.listQuery.dateFilter.length > 0) {
      //   let begin = vm.listQuery.dateFilter[0];
      //   let end = vm.listQuery.dateFilter[1];
      //   vm.formData.beginDate = begin;
      //   vm.formData.endDate = end;
      //   vm.formData.departureDate = begin;
      //   vm.formData.returnDate = end;
      // }

      vm.dialogFormVisible = true
      if (this.$refs['dynamicValidateForm']) {
        this.$refs['dynamicValidateForm'].clearValidate()
      }
    },
    async saveData(formName) {
      const vm = this
      this.formData.travelShortName = '-'
      if (this.isAdd) {
        if (
          !confirm(
            `旅遊團日期為${this.formData.beginDate}~${this.formData.endDate}，送出後無法更改，請再次確認是否正確?`
          )
        ) {
          return false
        }
      }
      if (!confirm(`確定要儲存資料?`)) {
        return false
      }
      if (vm.formData.position.length == 0) {
        if (
          !confirm(
            `目前所選擇的【國家/區域】沒有對應的天氣地點，若還是要儲存資料，App將不會有天氣可以顯示。確定要儲存?(可連絡系統管理員回報此問題，謝謝。)`
          )
        ) {
          return false
        }
      }
      let refUpload = this.$refs['uploadRef']
      let refUploadBoardRef = this.$refs['uploadBoardRef']

      // this.$refs["rightForm"].validate((valid) => {
      //   debugger
      //   if (!valid) {
      //     alert(valid);
      //     return false;
      //   }
      // });

      let webLinks = {
        officialEnable: 'official',
        fbEnable: 'fb',
        lineEnable: 'line',
        igEnable: 'ig',
        ytEnable: 'yt',
      }

      let webLinksDesc = {
        official: '官網',
        fb: 'FB',
        line: 'Line',
        ig: 'IG',
      }
      let expression =
        /http|https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      let validateWebSet = true
      Object.keys(webLinks).forEach(keys => {
        let enable = keys
        let link = webLinks[keys]
        let desc = webLinksDesc[link]
        if (vm.formData[enable]) {
          if (!vm.formData[link]) {
            vm.$message.error(`若要顯示【${desc}】連結，請填入【${desc}】連結，否則請關閉顯示。`)
            validateWebSet = false
            return
          } else {
            let protocol = vm.formData[link].substr(0, 4).toUpperCase()

            if (!protocol.startsWith('HTTP')) {
              vm.$message.error(`【${desc}】連結不是有效連結。`)
              validateWebSet = false
            } else {
              let regex = new RegExp(expression)
              let t = vm.formData[link]
              if (!t.match(regex)) {
                vm.$message.error(`【${desc}】連結不是有效連結。`)
                validateWebSet = false
                return
              }
            }
          }
        }
      })

      if (vm.formData.seminarMovieKind == 2 && !vm.formData.seminarMovieLink) {
        vm.$message.error(`請輸入說明會網址`)
        validateWebSet = false
      }

      //說明會網址不論有沒有選擇類型都會存所以分兩次判斷
      if (vm.formData.seminarMovieLink) {
        let protocol = vm.formData.seminarMovieLink.substr(0, 4).toUpperCase()

        if (!protocol.startsWith('HTTP')) {
          vm.$message.error(`說明會網址不是有效連結。`)
          validateWebSet = false
        } else {
          let regex = new RegExp(expression)
          let t = vm.formData.seminarMovieLink
          if (!t.match(regex)) {
            vm.$message.error(`說明會網址不是有效連結。`)
            validateWebSet = false
          }
        }
      }

      if (!validateWebSet) {
        return
      }

      this.$refs[formName].validate(async valid => {
        if (valid) {
          vm.formLoading = true

          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }

          debugger
          let boardPayload = await refUploadBoardRef.combineFileAndPayload()
          if (boardPayload) {
            payload.bulletinBoardData = {
              fileInfo: boardPayload.fileInfo,
              fileIDs: boardPayload.fileIDs,
            }
          }

          try {
            let res = await saveGroupTour(payload)
          } catch (error) {
            vm.formLoading = false
            return false
          }

          refUpload.clearFiles()
          refUploadBoardRef.clearFiles()
          vm.dialogFormVisible = false
          vm.formLoading = false
          await vm.refresh()
          // vm.defaultListyQuerySetting();
          // vm.getList();
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()

      let refUploadBoardRef = this.$refs['uploadBoardRef']
      refUploadBoardRef.clearFiles()
    },
    async getList() {
      const vm = this
      vm.listLoading = true
      await getGroupTourList(vm.listQuery).then(response => {
        response.data.data.forEach(f => {
          f.networkSettingLoading = false
        })

        vm.list = response.data.data
        vm.total = response.data.total
        vm.listLoading = false
      })
    },
    async editData(d) {
      const vm = this
      vm.selectedTravelID = d.id
      vm.isAdd = false
      this.travelName = d.travelName
      //為了要觸發Upload的watch beforeFileList
      vm.formData.fileInfo = []
      vm.formData.bulletinBoardData.fileInfo = []
      vm.modifyTourNo = d.tourGroupNo.startsWith('ep_temp_')

      //複製物件
      let jData = JSON.parse(JSON.stringify(d))
      vm.formData = jData

      vm.dialogFormVisible = true
    },
    // fatherCouponDialogFormVisible(action) {
    //   let vm = this;
    //   vm.dialogCouponFormVisible = action;
    // },
    // fatherCouponListDialogFormVisible(action) {
    //   let vm = this;
    //   vm.dialogCouponListVisible = action;
    // },
    // onCouponDialogClosed() {
    //   this.clearCouponFiles();
    // },
    async onPlanningDialogClosed() {
      this.clearPlanningFiles()
      await this.getList()
    },
    clearPlanningFiles() {
      let refCoupon = this.$refs['uploadHandbookRef']
      if (refCoupon) {
        refCoupon.clearFiles()
      }
    },
    clearCouponFiles() {
      let refCoupon = this.$refs['couponDataRef']
      if (refCoupon) {
        refCoupon.clearFiles()
      }
    },
    // 查看注意事項
    handleNoticeDialog() {
      this.noticeSettingVisible = true
      const params = { travelId: this.selectedTravelID }
      this.noticeSettingLoading = true
      getEditPage('TravelNotes', params)
        .then(res => {
          this.noticeContent = res.data.content || ''
          this.$refs[`tinymceNotice_${this.selectedTravelID}`].setValue(this.noticeContent)
          console.log(this.noticeContent)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.noticeSettingLoading = false
        })
    },
    // 編輯注意事項
    async handleSetNotice() {
      let contentFileInfo = []
      const fileContent = new File(
        [this.noticeContent],
        `noticeContent_${this.selectedTravelID}.txt`,
        {
          type: 'text/plain',
        }
      )
      const contentFileModel = {
        type: 34,
        files: [],
      }
      await convertFileToBase64(fileContent).then((resolve, reject) => {
        contentFileModel.files.push({
          fileName: `noticeContent_${this.selectedTravelID}.txt`,
          base64: resolve,
        })
        contentFileInfo.push(contentFileModel)
      })
      const params = {
        type: 'TravelNotes',
        contentFileInfo: [contentFileModel],
        param: {
          travelId: this.selectedTravelID,
        },
      }
      this.noticeSettingLoading = true
      saveEditPage(params)
        .then(res => {
          if (res.success) {
            this.$message({
              message: '注意事項內容修改完成',
              type: 'success',
            })
            this.noticeSettingVisible = false
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.noticeSettingLoading = false
        })
    },

    // 查看行程
    handleEditPlanDialog(day) {
      this.planDay = day
      this.planSettingVisible = true
      const params = { travelId: this.selectedTravelID, day: day }
      this.planSettingLoading = true
      getEditPage('TravelPlan', params)
        .then(res => {
          this.planContent = res.data.content || ''
          this.$refs[`tinymcePlan_${this.planDay}_${this.selectedTravelID}`].setValue(
            this.planContent
          )
          console.log(this.planContent)
          this.planContent = res.data.content
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.planSettingLoading = false
        })
    },
    // 編輯行程
    async handleSetPlan() {
      let contentFileInfo = []
      const fileContent = new File(
        [this.planContent],
        `planContent_${this.selectedTravelID}_${this.planDay}.txt`,
        {
          type: 'text/plain',
        }
      )
      const contentFileModel = {
        type: 34,
        files: [],
      }
      await convertFileToBase64(fileContent).then((resolve, reject) => {
        contentFileModel.files.push({
          fileName: `planContent_${this.selectedTravelID}_${this.planDay}.txt`,
          base64: resolve,
        })
        contentFileInfo.push(contentFileModel)
      })
      const params = {
        type: 'TravelPlan',
        contentFileInfo: [contentFileModel],
        param: {
          travelId: this.selectedTravelID,
          day: this.planDay,
        },
      }
      this.planSettingLoading = true
      saveEditPage(params)
        .then(res => {
          if (res.success) {
            this.$message({
              message: `Day${this.planDay} 行程內容修改完成`,
              type: 'success',
            })
            this.planSettingVisible = false
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.planSettingLoading = false
        })
    },

    handleClearNotice(done) {
      if (this.$refs[`tinymceNotice_${this.selectedTravelID}`]) {
        this.$refs[`tinymceNotice_${this.selectedTravelID}`].setValue('')
      }
      done()
    },
    handleCancelNotice() {
      if (this.$refs[`tinymceNotice_${this.selectedTravelID}`]) {
        this.$refs[`tinymceNotice_${this.selectedTravelID}`].setValue('')
      }
      this.noticeSettingVisible = false
    },
    handleClearPlan(done) {
      if (this.$refs[`tinymcePlan_${this.planDay}_${this.selectedTravelID}`]) {
        this.$refs[`tinymcePlan_${this.planDay}_${this.selectedTravelID}`].setValue('')
      }
      done()
    },
    handleCancelPlan() {
      if (this.$refs[`tinymcePlan_${this.planDay}_${this.selectedTravelID}`]) {
        this.$refs[`tinymcePlan_${this.planDay}_${this.selectedTravelID}`].setValue('')
      }
      this.planSettingVisible = false
    },
    // async saveCouponSuccess() {
    //   let vm = this;
    //   await vm.getTravelCoupons();
    // },
    // onCouponDiglogOpenHandler() {
    //   let couponRef = this.$refs["couponListRef"];
    //   if (couponRef) {
    //     couponRef.chkTravelID();
    //   }
    // },
    // 開啟複製多團彈窗
    duplicateMultipleTravel(row) {
      let d = JSON.parse(JSON.stringify(defaultCopyMultipleTraveler))
      this.duplicateTableFormData.tableData.push(d)
      this.duplicateTravelFormData = row
      this.dialogDuplicateMultipleTravelVisible = true
    },
    // 儲存複製多團
    async saveDuplicateMultipleTravel() {
      this.duplicateTableFormData.tableData.forEach(item => {
        if (item.dateRange) {
          item.beginDate = item.dateRange[0]
          item.endDate = item.dateRange[1]
        }
        if (!item.tourGroupNo) {
          this.$message.error('團號為必填項目')
          throw BreakException
        }
        if (!item.dateRange) {
          this.$message.error('日期區間為必填項目')
          throw BreakException
        }
        if (!item.beginTime) {
          this.$message.error('集合出發時間為必填項目')
          throw BreakException
        }
        if (!item.endTime) {
          this.$message.error('行程結束時間為必填項目')
          throw BreakException
        }
      })
      if (confirm(`旅遊團日期送出後無法更改，請再次確認是否正確？`)) {
        const params = {
          travel: this.duplicateTravelFormData,
          data: this.duplicateTableFormData.tableData,
        }
        this.duplicateMultipleTravelLoading = true
        await this.$store.dispatch(
          'app/showDownloadLoadingText',
          '正在複製旅行團中，請不要離開此畫面，感謝您的耐心等候。'
        )
        await this.$store.dispatch('app/showDownloadLoading', this.duplicateMultipleTravelLoading)
        duplicateTravelList(params)
          .then(async res => {
            this.dialogDuplicateMultipleTravelVisible = false
            this.duplicateMultipleTravelLoading = false
            await this.$store.dispatch(
              'app/showDownloadLoading',
              this.duplicateMultipleTravelLoading
            )
            await this.$store.dispatch('app/showDownloadLoadingText', '')
            if (res.success) {
              this.dialogDuplicateMultipleTravelResultVisible = true
              if (res.data.success) {
                res.data.success.forEach(value => {
                  this.duplicateMultipleTravelResult.push({
                    type: 'success',
                    group: value,
                  })
                })
              }
              if (res.data.fail) {
                res.data.fail.forEach(value => {
                  this.duplicateMultipleTravelResult.push({
                    type: 'fail',
                    group: value,
                  })
                })
              }
            } else {
              this.$message({
                message: '複製多團失敗',
                type: 'error',
              })
            }
          })
          .catch(async err => {
            console.log(err)
          })
          .finally(() => {
            setTimeout(async () => {
              this.duplicateMultipleTravelLoading = false
              await this.$store.dispatch(
                'app/showDownloadLoading',
                this.duplicateMultipleTravelLoading
              )
              await this.$store.dispatch('app/showDownloadLoadingText', '')
            }, 1500)
          })
      }
    },
    // 關閉複製多團彈窗
    dialogDuplicateMultipleTravelOnClose() {
      this.duplicateTableFormData.tableData = []
      this.duplicateTravelFormData = {}
    },
    async dialogDuplicateMultipleTravelResultOnClose() {
      this.duplicateMultipleTravelResult = []
      await this.getList()
    },
    handleAddNewCopyRow(row) {
      if (!row.dateRange || !row.beginTime || !row.endTime) {
        this.$message({
          message: '請填寫日期',
          type: 'error',
        })
        return
      }
      let d = JSON.parse(JSON.stringify(defaultCopyMultipleTraveler))
      d.dateRange = row.dateRange
      d.beginTime = row.beginTime
      d.endTime = row.endTime
      this.duplicateTableFormData.tableData.push(d)
    },
    handleDeleteNewCopyRow(row) {
      const indexToDelete = this.duplicateTableFormData.tableData.indexOf(row)

      if (indexToDelete !== -1) {
        this.duplicateTableFormData.tableData.splice(indexToDelete, 1)
      }

      if (
        this.duplicateTableFormData.tableData &&
        this.duplicateTableFormData.tableData.length < 1
      ) {
        let d = JSON.parse(JSON.stringify(defaultCopyMultipleTraveler))
        this.duplicateTableFormData.tableData.push(d)
      }
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding: 15px;
}

.seat-dialog .el-dialog__body {
  height: 830px;
  overflow-y: scroll;
}

.carryItem-dialog .el-dialog__body {
  height: calc(100vh - 150px);
}

.carryItem-dialog .el-dialog__body .el-tabs--border-card {
  height: 100%;
}

.carryItem-dialog .el-dialog__body .el-tabs__content {
  overflow-y: auto;
  height: 90%;
}

.el-input-group__prepend {
  background-color: #e6a23c;
  color: white;
}

.el-icon-circle-close {
  color: aliceblue;
}

.el-switch__label.el-switch__label--left > span {
  font-size: 12px !important;
}

.el-switch__label.el-switch__label--right > span {
  font-size: 12px !important;
}

.option_box {
  display: flex;
  align-items: center;
}

.option_img {
  width: 25px;
  height: 25px;
  margin-right: 7px;
}

.el-input-group__prepend {
  background-color: white !important;
}

.group-travel-main .svg-icon {
  width: 2em !important;
  height: 2em !important;
}

.web-link {
  margin: 5px;
}

.widh-input .el-form-item__content,
.widh-input input[type='text'] {
  width: 90%;
}

.travelers-div .el-input.is-disabled .el-input__inner {
  color: blue;
}

.manual .el-upload-list {
  position: absolute;
  user-select: auto;
  top: 0;
  left: 90px;
  max-width: 90%;
}

.video .el-upload-list {
  position: absolute;
  user-select: auto;
  top: 0;
  left: 60px;
  max-width: 90%;
}

.manual .el-upload-list__item:first-child {
  margin-top: 0px;
}

.video .el-upload-list__item:first-child {
  margin-top: 5px;
}

.editForm .el-dialog__title {
  color: red;
}
</style>

<style scoped>
/* /deep/:disabled {
  color: blue !important;
} */

/* /deep/.manual .el-upload__tip {
  position: absolute;
  width: 500px;
  top: -6px;
  left: 88px;
  user-select: auto;
}

/deep/.manual .el-upload-list {
  left: 83px;
  user-select: auto;
  position: relative;
  top: -10px;
} */
</style>

<style scoped>
.el-tab-pane {
  height: auto !important;
  /* overflow-y: auto; */
}
</style>

<style lang="scss">
.travel-data-cascader .el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}

.el-cascader-menu__wrap.el-scrollbar__wrap > ul > li:nth-child(1) > label {
  display: block !important;
}

.travelProperty-currency .el-form-item__content {
  width: 70%;
}

.listquery-target-point .el-cascader--medium {
  overflow: hidden;
}

.listquery-target-point .el-form-item__content {
  width: 100%;
}

.listquery-target-point .el-cascader__tags {
  top: 29px;
  left: 1px;
}

.listquery-target-point .el-cascader__search-input {
  display: none;
}

// .travelers-table {
//   height: 300px;
// }

// @media only screen and (max-width: 470px) {
//   .travelers-table {
//     height: 100px;
//   }
// }
@media (min-width: 1200px) {
  .edit-travel {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }
}

.other-setting {
  display: flex;
  gap: 10px;
}

.travel-time {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@media (min-width: 1200px) {
  .travel-time {
    flex-direction: row;
  }
}
</style>

<!-- 旅遊團建立方式 -->

<style scoped>
.custom-dialog {
  border-radius: 12px;
}

.el-dialog__header {
  padding: 10px 20px;
  background: #f0f2f5;
  border-radius: 12px 12px 0 0;
}

.el-dialog__headerbtn {
  top: 10px;
  right: 15px;
}

.el-dialog__title {
  font-size: 16px;
  color: #333;
  line-height: 1;
}

.el-dialog__body {
  padding: 15px;
}

.option-container {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}

.option {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: white;
  height: 100px;
  user-select: none;
}

.option.manual {
  background: linear-gradient(135deg, #36d1dc, #5b86e5);
}

.option.ai {
  background: linear-gradient(135deg, #ff9966, #ff5e62);
}

.option:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.option.active {
  transform: scale(0.95);
  box-shadow: inset 0 3px 7px rgba(0, 0, 0, 0.2);
  opacity: 0.9;
}

.option i {
  font-size: 32px;
  margin-bottom: 8px;
}

.option span {
  font-size: 14px;
  font-weight: bold;
}
</style>
